export const ventilationSystemAndFireProtectionCases = [
  {
    section: '1',
    title: 'בדיקת תכנון/התקנה',
    isTitle: true,
    subCases: [
      {
        section: '1.1',
        title: 'התקבלו תוכניות בטיחות מאושרות ע"י רשות כבאות והצלה',
        isTitle: false
      },
      {
        section: '1.2',
        title:
          'התקבל תיק מתקן מערכת הנידוף הכולל: תוכנית תוואי תעלות, שרטוטי מנדפים, מפרט יחידת סינון, מפרט מפוח, תעודת בדיקה 1001 חלק 7 למפוח אדי שומן.',
        isTitle: false
      },
      {
        section: '1.3',
        title:
          'ע"ג התוכניות מסומן תוואי תעלות עם סגירות / עטיפות 120 דקות, בהתאם למצוין בתוכניות הבטיחות, אזור אש שני.',
        isTitle: false
      },
      {
        section: '1.4',
        title: 'מסמכים ואישורים על בסיסם בוצע הבדיקה',
        isTitle: true
      },
      {
        section: '1.4.1',
        title: 'אישור בודק חשמל על המתקן',
        isTitle: false
      },
      {
        section: '1.4.2',
        title: 'תעודת בדיקת למערכת גילוי אש / עשן לפי ת"י 1220 חלק 3',
        isTitle: false
      },
      {
        section: '1.4.3',
        title: 'תעודות בדיקת מפוחים לפי ת"י 1001 חלק 7',
        isTitle: false
      },
      {
        section: '1.4.4',
        title:
          'תעודת בדיקת התקנת מערכת כיבוי אוטו\' באמצעות כימיקלים רטובים לפי ת"י 5356 חלק 2',
        isTitle: false
      }
    ]
  },
  {
    section: '4',
    title: 'דרישות כלליות',
    isTitle: true,
    subCases: [
      {
        section: '4.1',
        title: 'כללי',
        isTitle: true
      },
      {
        section: '4.1.1',
        title:
          'ציוד בישול המשמש בתהליכים המפיקים עשן, או אדים נושאי שומן, חייב להיות מצויד במערכת פליטה העומדת בכל דרישות הציוד והביצועים של תקן זה.',
        isTitle: false
      },
      {
        section: '4.1.7',
        title:
          'יישומי שכירויות מרובות מחייבים שיתוף פעולה בין השוכרים לבין בעלי הבניין בכל הנוגע לאחריות על התכנון, ההתקנה, ההפעלה והתחזוקה',
        isTitle: false
      },
      {
        section: '4.1.8',
        title:
          'כל שטחי הפנים של מערכת הפליטה חייבים להיות נגישים לצורכי ניקוי וביקורת.',
        isTitle: false
      },
      {
        section: '4.2',
        title: 'מרווח',
        isTitle: true
      },
      {
        section: '4.2.1',
        title:
          'כאשר כיסויים אינם נדרשים, המרווח בין מנדפים, מתקנים להסרת שומן, מאווררי פליטה ותעלות לבין חומר בעיר חייב להיות 457 מ"מ (18 אינץ\'), לפחות. המרווח בין כל אלה לבין חומר בעיר באופן מוגבל חייב להיות 76 מ"מ (3 אינץ\'), והמרווח בין כל אלה לבין חומר לא בעיר יכול להיות 0 מ"מ (0 אינץ\').',
        isTitle: false
      },
      {
        section: '4.2.2',
        title:
          'כאשר מנדף, תעלה או מתקן להסרת שומן רשומים למרווחים הקטנים מאלה הנדרשים בסעיף 4.2.1, מותרים המרווחים הנקובים בדרישות האישור.',
        isTitle: false
      },
      {
        section: '4.2.3',
        title: 'הפחתת מרווח',
        isTitle: true
      },
      {
        section: '4.2.3.1',
        title:
          'כאשר מערכת צמצום המרווח מורכבת מפח בעובי 0.33 מ"מ (0.013 אינץ\') (מידה 28) המותקן במרחק 25 מ"מ (1 אינץ\') על מרווחים לא בעירים, חובה להבטיח מרווח מזערי של 229 מ"מ (9 אינץ\') בין רכיבי המערכת לבין החומר הבעיר.',
        isTitle: false
      },
      {
        section: '4.2.3.2',
        title:
          'כאשר מערכת צמצום המרווח מורכבת מפח בעובי 0.69 מ"מ (0.027 אינץ\') (מידה 22) המותקן על קטעי צמר סלעים או שמיכת סיבים קרמיים מחוזקת בעינת תילים או חומרים שקילים אשר מותקנים במרחק 25 מ"מ (1 אינץ\') על מרווחים לא בעירים, חובה להבטיח מרווח מזערי של 76 מ"מ (3 אינץ\') בין רכיבי המערכת לבין החומר הבעיר.',
        isTitle: false
      },
      {
        section: '4.2.3.3',
        title:
          'כאשר מערכת הפחתת מרווח מכילה חומר עטיפת תעלה, מערכת, מוצר או שיטת בניה שרשומים ומתויגים למטרה זו, על פי תקן ASTM E2336, המרווח הנדרש יהיה בהתאם לדרישות הרישום.',
        isTitle: false
      },
      {
        section: '4.2.3.4',
        title:
          'פינוי אפס לחומרים דליקים מוגבלים יהיה מותר כאשר הוא מוגן על ידי אחד מאלה:\n(1) מתכת וטיח\n(2) אריחי קרמיקה\n(3) אריח מחצבה\n(4) חומרים או מכלול חומרים בלתי דליקים אחרים רשומים למטרת הקטנת מרווח\n(5) חומרים ומוצרים אחרים הרשומים לצורך הקטנת מרווח',
        isTitle: false
      },
      {
        section: '4.2.4',
        title: 'שלמות מרווח',
        isTitle: true
      },
      {
        section: '4.2.4.1',
        title:
          'במקרה של נזק, יש לתקן את החומר או המוצר ולהביאו למצב שבו הוא עומד בדרישות האישור או המרווח, ובאופן שהתיקון יהיה קביל על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '4.2.4.2',
        title:
          'במקרה של אש במערכת הפליטה של המטבח, התעלה והעטיפה שלה (פיר מדורג, עטיפה תעלת שומן מיוצר במפעל, או עטיפה תעלת שומן מיושם בשטח) חייבים לעבור ביקורת בידי עובד מוסמך כדי לבחון את תקינות מבנה התעלה ואמצעי ההגנה שלה. עליו גם לוודא כי הם כשירים להגן על המערכת מפני אש ועומדים בדרישות תקן זה לצורכי המשך ההפעלה.',
        isTitle: false
      },
      {
        section: '4.2.4.3',
        title:
          'על גבי הקיר, החל בתחתית המנדף ועד הרצפה, או עד חלקו העליון של החומר הלא בעיר הפרוש עד הרצפה, יש להבטיח מיגון ברמה הנדרשת בסעיף 4.2.1.',
        isTitle: false
      },
      {
        section: '4.2.4.4',
        title:
          'יישום אמצעי המיגון לתעלות המיועדים לצמצם את המרווח לא ייעשה על התעלה עצמה, אלא על המבנה הבעיר או למבנה בעל כושר הבעירה המוגבל',
        isTitle: false
      },
      {
        section: '4.3',
        title: 'עטיפות תעלות שומן המיושמים בשטח וכאלה המיוצרים במפעל',
        isTitle: true
      },
      {
        section: '4.3.1',
        title:
          "יש להגן על עטיפות תעלות שומן המיושמים בשטח באמצעות מערכת עצירת אש המסווגת על פי תקן ת\"י 931 חלק 2 - עמידות אש של אלמנטי בניין - שיטות בדיקה של מערכות אטימה מפני אש ותוצריה או תקן ANSI/UL 1479 בעלי דירוג 'F' ודירוג 'T' השווה לדירוג האש של המכלל הנחדר.",
        isTitle: false
      },
      {
        section: '4.3.1.1',
        title:
          'פני השטח של תעלת השומן המיוצרת בשטח יהיו מכוסים ברצף מכל צד מן הנקודה שבה עטיפה התעלה חודר דרך תקרה, קיר או רצפה לעבר היציאה.',
        isTitle: false
      },
      {
        section: '4.3.1.2',
        title:
          'עטיפה תעלת השומן המיושם בשטח חייב להיות רשום על פי תקן ASTM E 2336 ומותקן על פי הוראות היצרן ודרישות האישור.',
        isTitle: false
      },
      {
        section: '4.3.2',
        title:
          'כאשר הם חשופים לנזקים פיזיים, יש להגן על עטיפות תעלות שומן המיושמים בשטח כפי שנחשב נחוץ על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '4.3.3',
        title:
          "ההגנה על עטיפות תעלות שומן המיוצרים במפעל תיעשה באמצעות מערכת עצירת אש המסווגת על פי תקן ת\"י 931 חלק 2 - עמידות אש של אלמנטי בניין - שיטות בדיקה של מערכות אטימה מפני אש ותוצריה או תקן ANSI/UL 1479 בדירוג 'F' ודירוג 'T' השווה לדירוג האש של המכלל הנחדר מהנקודה שבה התעלה חודרת דרך תקרה, קיר או רצפה לעבר היציאה.",
        isTitle: false
      },
      {
        section: '4.3.3.1',
        title:
          'מערכת ההגנה של תעלות שומן המיוצרות במפעל חייבת להיות רשומה על פי תקן UL 2221.',
        isTitle: false
      },
      {
        section: '4.3.3.2',
        title:
          'תעלות השומן הרשומות המיוצרות במפעל, בעלות קיר בודד,  יותרו לעטיפה בשטח באמצעות חומר המאושר לעטיפה ביחד עם התעלה, ומותקנים בהתאם להוראות יצרן תעלות השומן.',
        isTitle: false
      },
      {
        section: '4.3.3.3',
        title:
          'מערכת ההגנה של תעלות שומן המיוצרות במפעל חייבת להיות מותקנת על פי הוראות היצרן ודרישות האישור.',
        isTitle: false
      },
      {
        section: '4.3.4',
        title:
          'יש להוכיח כי עטיפות תעלות שומן המיושמים בשטח וכאלה המיוצרים במפעל מבטיחים שלמות מכנית, שלמות מבנית, גמישות ויציבות כאשר הם נחשפים לתנאי הסביבה האמורים להתקיים בבניין, לתנועת התעלה בתנאי הפעלה רגילים, ולתנועת התעלה בתנאי שריפה.',
        isTitle: false
      },
      {
        section: '4.3.5',
        title:
          'מפרטי החומר, מידת העובי ומבנה התעלה, המשמשים בבדיקות וברישום של עטיפות תעלות שומן המיושמים בשטח וכאלה המיוצרים במפעל, חייבים להיות כלולים כדרישות מינימום במסגרת תיעוד האישור וההתקנה.',
        isTitle: false
      },
      {
        section: '4.3.6',
        title:
          'אופציות המרווחים לעטיפות תעלות שומן המיושמים בשטח וכאלה המיוצרים במפעל. אפשרויות המרווחים שלהלן, שנבחנו בהצלחה עבור עטיפות תעלות שומן המיושמים בשטח או המיוצרים במפעל, יצוינו בבירור בתיעוד האישור וההתקנה ועל התגים המלווים את הציוד:\n(1) מרווח מבנה בעיר פתוח על פי הממדים הנדרשים על ידי היצרן\n(2) מרווח מבנה בעיר סגור על פי הממדים הנדרשים על ידי היצרן, עם אוורור מוגדר או בלעדיו\n(3)  מרווח פיר מדורג על פי הממדים הנדרשים על ידי היצרן, עם אוורור מוגדר או בלעדיו',
        isTitle: false
      },
      {
        section: '4.4',
        title: 'מגע בין בניין ותעלה מבנית.',
        isTitle: true
      },
      {
        section: '4.4.1',
        title:
          'מותר מגע בין תעלה לבין רצפות לא בעירות, קירות פנימיים לא בעירים, ומבנים ותמוכות לא בעירים אחרים, אולם אסור שהיקף מגע זה יעלה על 50% משטח התעלה, לכל קטע של התעלה שאורכו רגל אחת.',
        isTitle: false
      },
      {
        section: '4.4.2',
        title:
          'כאשר מגע התעלה חייב לחרוג מדרישות סעיף 4.4.1, חובה להגן על התעלה מפני שיתוך.',
        isTitle: false
      },
      {
        section: '4.4.3',
        title:
          'כאשר התעלה רשומה להתקנה במרווח אפס מחומרים בעירים, או מוגנת באופן אחר באמצעות חומר או מוצר הרשום לשימוש לצורכי צמצום המרווח לאפס, מותר לחרוג ממגבלות המגע המוגדרות בסעיף 4.4.1 ללא מיגון נוסף מפני שיתוך.',
        isTitle: false
      },
      {
        section: '4.4.4',
        title:
          'כאשר התעלה רשומה להתקנה במרווח אפס מחומרים בעירים, מותר לחרוג ממגבלות המגע המוגדרות בסעיף 4.4.1 ללא מיגון נוסף מפני שיתוך.',
        isTitle: false
      },
      {
        section: '4.5',
        title:
          'מרווחים בין תעלות לבין כיסויים \nהמרווחים בין התעלה לבין שטחם הפנימי של העטיפות חייבים לעמוד בדרישות סעיף 4.2.',
        isTitle: false
      },
      {
        section: '4.6',
        title:
          'שרטוטים. \nחובה להחזיק בבניין את שרטוטי ההתקנה של מערכת הפליטה, את עותק הוראות ההפעלה של מכללי המשנה והרכיבים המשמשים במערכת הפליטה, כולל תרשימי מערכת החשמל.\nהערה:\nהכיתוב על גבי הסרטוטים יהיה בשפה העברית. מותר כיתוב בשפה אחרת, נוסף על הכיתוב בשפה העברית.',
        isTitle: false
      }
    ]
  },
  {
    section: '5',
    title: 'מנדפים',
    isTitle: true,
    subCases: [
      {
        section: '5.1',
        title: 'מבנה',
        isTitle: true
      },
      {
        section: '5.1.1',
        title:
          'המנדף או החלק הזה של האמצעי העיקרי לקליטת אדי הבישול והשיירים, חייב להיות בנוי ונתמך על ידי פלב"ם שעובייה המזערי הוא 0.91 מ"מ (0.036 אינץ\'), (No. 20 MSG) או על ידי חומר מאושר אחר בעל חוזק ועמידות באש ובשיתוך שקילים.',
        isTitle: false
      },
      {
        section: '5.1.2',
        title:
          'כל התפרים, החיבורים והחדירות של עטיפה המנדף המפנה את אדי השומן ואת גזי הפליטה ולוכד אותם, חייבים להיות מרותכים להיקפו התחתון של המנדף בריתוך חיצוני רציף ואטום לנוזלים.',
        isTitle: false
      },
      {
        section: '5.1.3',
        title:
          'תפרים, חיבורים וחדירות של המנדף יכולים להיות מרותכים מבפנים, בתנאי שהריתוך הוא חלק או מוחלק בהשחזה, באופן המונע לכידת שומן ומאפשר לנקותו בנוחות.',
        isTitle: false
      },
      {
        section: '5.1.4',
        title:
          'חיבורים ותפרים פנימיים של המנדף, מסגרות התמיכה למסנן והאבזרים המותקנים בתוכו, חייבים להיות אטומים או מוגנים באופן אחר מפני חדירת שומן',
        isTitle: false
      },
      {
        section: '5.1.5',
        title:
          'מותר לאטום את החדירות באמצעות רכיבים הרשומים למטרה זו, ובלבד ששימוש ברכיבים אלה אינו פוגע בשלמות המבנית של המנדף או של התעלה',
        isTitle: false
      },
      {
        section: '5.1.6',
        title:
          'מנדפי פליטה רשומים, עם מדפי פליטה או בלעדיהם, יכולים להיות בנויים מחומרים הנדרשים באישור.',
        isTitle: false
      },
      {
        section: '5.1.7',
        title:
          'מותר להרכיב את מנדפי הפליטה הרשומים, עם מדפי פליטה או בלעדיהם, על פי דרישות האישור.',
        isTitle: false
      },
      {
        section: '5.1.8',
        title: 'מנדפים מסוג גבה (eyebrow)',
        isTitle: true
      },
      {
        section: '5.1.8.1',
        title:
          'מותר לחבר את מנדפי הגבה (eyebrow), המותקנים מעל תנורי גז או תנורי חשמל, לתעלה הבנויה כנדרש בפרק 7, החל בארובת התנור המחוברת לחופת המנדף במעלה תאי אוויר (פלנום) הפליטה – ראה איור 5.1.8.1.',
        isTitle: false
      },
      {
        section: '5.1.8.2',
        title:
          'יש לחבר את התעלה שבין ארובת התנור לבין חופת המנדף באמצעות ריתוך רציף. לחלופין יש לחברם בחיבור שבין תעלות [ראה איורים 8.1.2.2(ב) עד 8.1.2.2(ד)].',
        isTitle: false
      },
      {
        section: '5.1.9',
        title:
          'חומרי הבידוד, למעט בידוד חשמלי, יהיו בעלי סיווג לפי תגובה בשריפה Class B ודרגת צפיפות עשן S1 לפי התקן הישראלי ת"י 755.',
        isTitle: false
      },
      {
        section: '5.1.10',
        title:
          'דבקים או צמנטים המשמשים בהתקנת חומרי בידוד חייבים לעמוד בדרישות סעיף 5.1.9, בבדיקה עם חומר הבידוד הספציפי.',
        isTitle: false
      },
      {
        section: '5.1.11',
        title: 'החדירות ייאטמו ברכיבים רשומים על פי דרישות סעיף 5.1.12.',
        isTitle: false
      },
      {
        section: '5.1.12',
        title:
          'מתקנים המחייבים חדירת המנדף, דוגמת אבזרי/מהדקי צינורות ומוליכים, חייבים להיות רשומים על פי תקן ANSI/UL 1978.\nלמרות האמור לעיל, מותר להשתמש בהתקנים המתאימים לתקנים רלוונטיים מקבילים',
        isTitle: false
      },
      {
        section: '5.1.13',
        title:
          'מכללי מנדף פליטה המיועדים להרכבה על קיר חייבים להיות מוצמדים באופן הדוק לקיר האחורי כדי שלא לאפשר מעבר של אדי שומן מאחורי המנדף או בין הקיר האחורי לבין מכלל המנדף.',
        isTitle: false
      },
      {
        section: '5.3',
        title: 'מכללי מנדפי פליטה עם תאי אוויר (פלנום) משולבים לאספקת אוויר',
        isTitle: true
      },
      {
        section: '5.3.1',
        title:
          'מבנה המכללים של מנדפי פליטה עם תאי אוויר (פלנום) משולבים להספקת אוויר וממדיהם חייבים לעמוד בדרישות סעיפים 5.1 ו‑5.2.',
        isTitle: false
      },
      {
        section: '5.3.2',
        title:
          'מבנה של עטיפה חיצוני או מבנה של עטיפה פליטה פנימי חייב לעמוד בהוראות סעיף 5.1.',
        isTitle: false
      },
      {
        section: '5.3.3',
        title:
          'כאשר העטיפה החיצוני מרותך, מבנה העטיפה הפנימי חייב להיות אטום לשומן.',
        isTitle: false
      },
      {
        section: '5.3.4',
        title:
          'מדפי אש\nהערה:\nבמנדפים שבהם יש תא לאספקת אוויר שאינו מחובר לתעלה חיצונית, \nאו לתעלה שאינה מספקת אוויר למנדפים אחרים, אין צורך להתקין מדף אש.',
        isTitle: false
      },
      {
        section: '5.3.4.1',
        title:
          'בתא הקיבול של הספקת האוויר, יש להתקין מדף (Dumper) מופעל אש בכל נקודה שבה פתח הכניסה לתעלת הספקת האוויר, או פתח היציאה ממנה, חודר דרך עטיפה מרותך ברציפות של המכלל',
        isTitle: false
      },
      {
        section: '5.3.4.2',
        title: 'מדפי האש יתאימו לדרישות התקן הישראלי ת"י 1001 חלק 3',
        isTitle: false
      },
      {
        section: '5.3.4.3',
        title: 'מתקן ההפעלה חייב להיות בדירוג טמפרטורה מרבי של 141ºC (286ºF).',
        isTitle: false
      },
      {
        section: '5.3.4.4',
        title:
          'תאי אוויר (פלנום) להספקת אוויר הפולטים אוויר מלפנים ולא מחלקם התחתון, או תאים הפולטים אותו לתוך מנדף פליטה ומבודדים ממנו בעטיפה מרותך ברציפות המגיע להיקפו התחתון החיצוני של מכלל המנדף כולו אינם דרושים למדף (Dumper) מופעל אש. (ראה תרשים A באיור A.5.3.4).',
        isTitle: false
      },
      {
        section: '5.4',
        title: 'מכללי מנדף רשומים',
        isTitle: true
      },
      {
        section: '5.4.1',
        title:
          'יש להתקין את מכללי המנדפים הרשומים על פי תנאי האישור ובהתאם להוראות היצרן.',
        isTitle: false
      },
      {
        section: '5.4.2',
        title:
          'יש לבדוק את מכללי המנדפים הרשומים על פי תקן UL 710 או תקן שקיל.',
        isTitle: false
      },
      {
        section: '5.5',
        title:
          'מנדפי אולטרה‑סגול רשומים. \nיש להתקין ולתחזק את מנדפי האולטרה‑סגול הרשומים על פי תנאי האישור ובהתאם להוראות היצרן.',
        isTitle: true
      },
      {
        section: '5.5.1',
        title:
          'מערכות תעלות המחוברות למנדפים בעלי קרינת אולטרה‑סגול חייבות לעמוד בדרישות פרק 7.',
        isTitle: false
      },
      {
        section: '5.5.2',
        title:
          'יש לבדוק ולרשום את מנדפי האולטרה‑סגול על פי תקן UL 710 ותקן UL 710C.',
        isTitle: false
      },
      {
        section: '5.6',
        title:
          'טכנולוגיית תקרה מאווררת רשומה. \nיש להתקין ולתחזק את טכנולוגיית התקרה המאווררת הרשומה על פי תנאי האישור ובהתאם להוראות היצרן.',
        isTitle: false
      }
    ]
  },
  {
    section: '6',
    title: 'מתקנים להסרת שומן במנדפים',
    isTitle: true,
    subCases: [
      {
        section: '6.1',
        title: 'מתקנים להסרת שומן',
        isTitle: true
      },
      {
        section: '6.1.1',
        title:
          'יש להתקין מסנני שומן רשומים או מתקנים אחרים רשומים להסרת שומן לשימוש עם ציוד לבישול מסחרי.',
        isTitle: false
      },
      {
        section: '6.1.2',
        title:
          'יש לרשום את מסנני השומן הרשומים ואת המתקנים הרשומים להסרת שומן – שהם רכיבים נשלפים אך לא חלק אינטגרלי מקולט אדים ספציפי רשום – יהיו מאושרים על פי תקן UL 1046.',
        isTitle: false
      },
      {
        section: '6.1.3',
        title:
          'אין להשתמש במסנני עינה אלא אם הם מוערכים כחלק בלתי נפרד מקולט אדים הרשום בשילוב עם מסנן עיקרי על פי תקן UL 1046.',
        isTitle: false
      },
      {
        section: '6.2',
        title: 'התקנה',
        isTitle: true
      },
      {
        section: '6.2.1',
        title: 'מרחק הפרדה',
        isTitle: true
      },
      {
        section: '6.2.1.1',
        title:
          'המרחק בין המתקן להסרת שומן לבין משטח הבישול חייב להיות גדול ככל האפשר, אך לא קטן מ‑457 מ"מ (18 אינץ\').',
        isTitle: false
      },
      {
        section: '6.2.1.2',
        title:
          'כאשר מתקנים להסרת שומן משמשים עם אסכלות פחם עץ, או מסוג פחם עץ, לרבות אסכלות מחוממות בגז או בחשמל, יש לשמור על מרחק אנכי של 1.22 מטר (4 רגל), מינימום, בין חלקו התחתון של המתקן להסרת שומן לבין משטח הבישול.',
        isTitle: false
      },
      {
        section: '6.2.1.3',
        title:
          'בציוד בישול הנעדר להבה חשופה, וגזי הארובה עוקפים בו את המתקנים להסרת שומן, אפשר להקטין את המרחק האנכי האמור למינימום של 152 מ"מ (6 אינץ\').',
        isTitle: false
      },
      {
        section: '6.2.1.4',
        title:
          'כאשר מתקן להסרת שומן רשום למרחקי הפרדה קטנים מאלה הנדרשים בסעיפים 6.2.1.1 ו‑6.2.1.2, יש להתיר את המרחקים הנקובים בדרישות האישור.',
        isTitle: false
      },
      {
        section: '6.2.1.5',
        title:
          'יש להתקין מתקנים להסרת שומן המסופקים כחלק ממכללי המנדפים הרשומים על פי תנאי האישור ובהתאם להוראות היצרן.',
        isTitle: false
      },
      {
        section: '6.2.2',
        title: 'הגנה על מתקן להסרת שומן',
        isTitle: true
      },
      {
        section: '6.2.2.1',
        title:
          'כאשר המרחק בין מתקן להסרת שומן לבין פתח היציאה של ארובת המכשיר (מקור החום) קטן מ‑457 מ"מ (18 אינץ\'), במהלך פעולתם הרגילה של מכשירי הבישול, המפיקים גזי ארובה חמים מאד, חובה להגן על מתקנים להסרת שומן מפני פתחי היציאה של גזי הבעירה ומפני פגיעה ישירה של הלהבה.',
        isTitle: false
      },
      {
        section: '6.2.2.2',
        title:
          'אפשר לבצע הגנה זו על ידי התקנת לוחית חוצצת, העשויה פלדה או פלב"ם, בין מקור החום לבין המתקן להסרת השומן.',
        isTitle: false
      },
      {
        section: '6.2.2.3',
        title:
          'בממדי הלוחית החוצצת ובמיקומה יהיה כדי לחייב את הלהבות או את גזי הבעירה לעבור מרחק שאינו קטן מ‑457 מ"מ (18 אינץ\') בין מקור החום לבין המתקן להסרת השומן.',
        isTitle: false
      },
      {
        section: '6.2.2.4',
        title:
          'יש למקם את הלוחית החוצצת במרחק שאינו קטן מ‑152 מ"מ (6 אינץ\') מן המתקנים להסרת שומן.',
        isTitle: false
      },
      {
        section: '6.2.3',
        title: 'מסנני שומן',
        isTitle: true
      },
      {
        section: '6.2.3.1',
        title: 'על מסנני השומן להיות רשומים ומאושרים.',
        isTitle: false
      },
      {
        section: '6.2.3.2',
        title: 'מסנני השומן יהיו בנויים מחומרים לא בעירים.',
        isTitle: false
      },
      {
        section: '6.2.3.3',
        title:
          'מסנני השמן יהיו בנויים מחומר קשיח שלא יתעוות או יימעך תחת תנאי הפעלה , טיפול וניקוי רגילים.',
        isTitle: false
      },
      {
        section: '6.2.3.4',
        title: 'מסנני השומן יסודרו כך שכל האוויר הנפלט יעבור דרכם.',
        isTitle: false
      },
      {
        section: '6.2.3.5',
        title: 'מסנני שומן יהיו קלים לגישה לטובת הסרתם',
        isTitle: false
      },
      {
        section: '6.2.3.6',
        title:
          'מסנני השומן יותקנו בזווית שאינה קטנה מ-45 מעלות מהמישור האופקי.\nדרישה זו אינה חלה על מסנן המותקן במכלל תקרה המשמש מנדף. בתקרה זו מותר להתקין את המסננים ללא שיפוע, אם ננקטו כל האמצעים הדרושים למניעת טפטוף השומנים מהתקרה.',
        isTitle: false
      },
      {
        section: '6.2.4',
        title: 'מגשי איסוף (טפטוף) שומן',
        isTitle: true
      },
      {
        section: '6.2.4.1',
        title: 'יש להתקין מגשים לאיסוף השומן מתחת מסנני השומן.',
        isTitle: false
      },
      {
        section: '6.2.4.2',
        title:
          'הממדים של מגשי איסוף השומן יצומצמו למינימום הנדרש לקליטת השומן.',
        isTitle: false
      },
      {
        section: '6.2.4.3',
        title:
          "יש להטות את מגשי איסוף השומן לעבר מכל מתכתי סגור בעל קיבולת שאינה עולה על 3.8 ל' (1 גלון).",
        isTitle: false
      },
      {
        section: '6.2.5',
        title:
          'כיוון מסנן השומן\nמסנני השומן המחייבים התקנה בכיוון ספציפי כדי לנקז את השומן יסומנו בבירור, ולחלופין מבנה המנדף חייב למנוע התקנה בכיוון הלא נכון.',
        isTitle: false
      }
    ]
  },
  {
    section: '7',
    title: 'מערכות תעלות פליטה',
    isTitle: true,
    subCases: [
      {
        section: '7.1',
        title: 'כללי',
        isTitle: true
      },
      {
        section: '7.1.1',
        title: 'אין להעביר תעלות דרך קירות אש. (ראו גם סעיף 7.7)',
        isTitle: false
      },
      {
        section: '7.1.2',
        title:
          'על כל התעלות להוליך ישירות אל מחוץ לבניין. זאת, כדי למנוע הגברת סיכוני האש, שלא לצורך.',
        isTitle: false
      },
      {
        section: '7.1.3',
        title:
          'אין לחבר את מערכות התעלות עם מערכות אוורור או פליטה אחרות בבניין.',
        isTitle: false
      },
      {
        section: '7.1.4',
        title:
          "כל התעלות יותקנו עם שיפוע מינימלי של 2 אחוזים בתעלות אופקיות באורך של עד 22.86 מ '(75 רגל) ובזווית מינימלית של 8 אחוזים בתעלות אופקיות באורך העולה על 22.86 מ' (75 רגל).\nבמקרה של התקנות חדשות בבניינים קיימים יש לעמוד באחד משני התנאים המפורטים להלן:\n- אם קיים שיפוע, הוא יהיה כנדרש בתקן ישראלי זה וייבדק כנדרש על ידי הרשות המוסמכת (ראו הגדרה 3.2.2)\n- אם מדובר בתעלה אופקית (ללא שיפוע), היא תיבדק כנדרש על ידי הרשות המוסמכת (ראו הגדרה 3.2.2) בתדירות של פעם בחודש.",
        isTitle: false
      },
      {
        section: '7.1.4.1',
        title:
          'תעלות שומן בנויות במפעל יותרו להתקנה בשיפוע קטן יותר בהתאם לתנאי הרישום ולהנחיות היצרן.',
        isTitle: false
      },
      {
        section: '7.1.4.2',
        title: 'לכל התעלות האופקיות תסופק גישה בהתאם לסעיף 7.4.1',
        isTitle: false
      },
      {
        section: '7.1.4.3',
        title: 'יש להתקין פתח ניקוז בנקודות נמוכות בתעלות אופקיות.',
        isTitle: false
      },
      {
        section: '7.1.4.3.1',
        title:
          'היכן שסופקו, אלמנטי הניקוז ירותכו ריתוך רציף לתעלת הפליטה בהתאם לתנאי הרישום ולמדריך ההתקנה של היצרן.',
        isTitle: false
      },
      {
        section: '7.1.4.4',
        title: 'כל התעלות יותקנו בצורה כזו שלא יווצרו שלוליות או מלכודות.',
        isTitle: false
      },
      {
        section: '7.1.4.5',
        title:
          'במערכות סעפת (תעלות רגילות), חיבור הקצה התחתון של התעלה הראשית חייב להיות במישור אחד עם תחתית תעלת השלוחה (branch duct).',
        isTitle: false
      },
      {
        section: '7.1.4.6',
        title:
          "יש לאפשר לתעלות פליטה המשמשות במערכות אוורור מכשירי משב יורד לכלול עלייה של התעלה בתנאי שהשטח הלכוד מכיל נקז נקודה נמוכה למאגר שומן מאושר אשר הקיבולת שלו אינה עולה על 3.8 ל' (1 גלון) והתעלה נגישה בקלות לניקוי לכל אורכה.",
        isTitle: false
      },
      {
        section: '7.1.6',
        title:
          'יש לסמן את כל פתחי הגישה בנוסח הבא:\nACCESS PANEL — DO NOT OBSTRUCT\nנוסף על נוסח השלט באנגלית, ייכתב השלט גם בעברית, כמפורט להלן:\nפתח גישה - אסור לחסום\nגודל האותיות יהיה 25 מ"מ, צבען יהיה אדום והן יופיעו על רקע לבן.',
        isTitle: false
      },
      {
        section: '7.1.7',
        title:
          'יש להתקין את מכללי המנדפים הרשומים על פי תנאי האישור ובהתאם להוראות היצרן.',
        isTitle: false
      },
      {
        section: '7.3',
        title: 'פתחים',
        isTitle: true
      },
      {
        section: '7.3.1',
        title:
          'יש להתקין פתחים בצדי התעלה או בחלקה העליון, הנגיש מביניהם, ובנקודות של תפנית בכיוון.',
        isTitle: false
      },
      {
        section: '7.3.2',
        title:
          'יש להגן על הפתחים באמצעות גישה מאושרת הבנויה ומותקנת על פי דרישות סעיף 7.4.4.',
        isTitle: false
      },
      {
        section: '7.3.3',
        title:
          'פתחים אינם נדרשים בחלקי התעלה הנגישים דרך קצה הכניסה או דרך קצה הפליטה.',
        isTitle: false
      },
      {
        section: '7.3.4',
        title:
          'במנדפים המצוידים במדפים (Dumpers) בתוך צווארון הפליטה או ההספקה, יש להתקין בתעלה או במנדף פתח גישה לצורכי ניקוי וביקורת במרחק שאינו מעל 457 מ"מ (18 אינץ\') מן המדף (Dumper).',
        isTitle: false
      },
      {
        section: '7.3.5',
        title:
          'במערכות תעלות פליטה נפוצות יש להתקין פתחי פתחי גישה למטרת התקנה וטיפול במערכת כיבוי האש.',
        isTitle: false
      },
      {
        section: '7.3.6',
        title:
          'פתחי פתחי גישה אינם נדרשים בקטעי תעלת פליטה רגילה, או בתעלת שלוחה, הנגישים דרך חיבור שבין תעלת השלוחה לבין מנדף הפליטה.',
        isTitle: false
      },
      {
        section: '7.3.7',
        title:
          'למאוורר פליטה המחובר משני צדיו לתעלות יש להתקין, משני צדי המאוורר ובמרחק שאינו מעל 0.92 מטר (3 רגל) ממנו, פתחי גישה לניקוי ולביקורת.',
        isTitle: false
      },
      {
        section: '7.3.8',
        title:
          "למאוורר פליטה תלוי על קיר יש להתקין במרחק 1מ' פתח גישה לניקוי ולביקורת של מאוורר הפליטה.",
        isTitle: false
      },
      {
        section: '7.4',
        title: 'פתחים בתעלות כל הפתחים יעמדו בדרישות סעיף זה.',
        isTitle: true
      },
      {
        section: '7.4.1',
        title: 'תעלות אופקיות',
        isTitle: true
      },
      {
        section: '7.4.1.1',
        title:
          'בתעלות אופקיות, יש להתקין לפחות פתח אחד בגודל 508 מ"מ × 508 מ"מ (20 אינץ\' × 20 אינץ\') לכניסת אנשי צוות',
        isTitle: false
      },
      {
        section: '7.4.1.2',
        title:
          'במקום שפתח במידות שצוינו בסעיף 7.4.1.1 אינו אפשרי, יש להתקין פתחים גדולים מספיק כדי לאפשר ניקוי במרווחים של 3.7 מטר (12 רגל).',
        isTitle: false
      },
      {
        section: '7.4.1.3',
        title:
          'אם הפתחים שבמערכות תעלות שומן אופקיות אינם נגישים בנוחות מסולם שלבים בגובה 3 מטר (10 רגל), יש להתקינם עם גישה בטוחה ומשטח הרמה.\nמשטח העבודה (work platform) יהיה מסוג משטח נייד.',
        isTitle: false
      },
      {
        section: '7.4.1.4',
        title:
          'מבני התמיכה במערכות תעלות שומן אופקיות שממדיהן הם לפחות 609 מ"מ (24 אינץ\'), בכל גודל חתך, יתוכננו, בכל נקודה של המערכת, לעומס השווה למשקל התעלות בתוספת 363 ק"ג (800 ליב\').',
        isTitle: false
      },
      {
        section: '7.4.1.5',
        title:
          'במערכת תעלות שלא עברה אישור במעבדה, קצה הפתח  יהיה מרוחק לפחות 38.1 מ"מ (11/2 אינץ\') מכל השפות החיצוניות של התעלה או מתפרי הריתוך שלה.',
        isTitle: false
      },
      {
        section: '7.4.2',
        title: 'תעלות אנכיות',
        isTitle: true
      },
      {
        section: '7.4.2.1',
        title:
          'במערכת תעלות אנכיות שכניסת עובדים לתוכן אפשרית יש למקם את פתח הגישה בחלקה העליון של התעלה האנכית כדי לאפשר ירידה.',
        isTitle: false
      },
      {
        section: '7.4.2.2',
        title:
          'כאשר כניסת העובדים אינה אפשרית, יש להבטיח, בכל אחת מן הקומות, גישה הולמת לצורכי ניקוי.',
        isTitle: false
      },
      {
        section: '7.4.2.3',
        title:
          'אם פתחיהן של תעלות שומן אנכיות אינם נגישים בנוחות מהרצפה או מסולם שלבים בגובה 3 מטר (10 רגל), יש להתקינם עם גישה בטוחה ומשטח הרמה.',
        isTitle: false
      },
      {
        section: '7.4.2.4',
        title:
          'במערכת תעלות שלא עברה אישור במעבדה, קצה הפתח יהיה מרוחק לפחות 38.1 מ"מ (11/2 אינץ\') מכל השפות החיצוניות של התעלה או מתפרי הריתוך שלה.',
        isTitle: false
      },
      {
        section: '7.4.2.5',
        title:
          'ניתן להשתמש במתקן מכני/רובוט לניקוי תעלות מנדף, אם מתקיימים התנאים המפורטים להלן:\n- יש מקור מים במפלס הגג;\n- יש חיבור חשמל מתאים;\n- יש פתח גישה של מתקן השטיפה בתוך חלל התעלה;\n- יש ניקוז בתחתית תעלת המנדף;\n- יש פתח גישה בתחתית תעלת המנדף.\nבאזורים שבהם משתמשים במתקן מכני/רובוט לניקוי תעלות מנדף, פתחי שירות אינם נדרשים.',
        isTitle: false
      },
      {
        section: '7.4.3',
        title: 'פתחי גישה',
        isTitle: true
      },
      {
        section: '7.4.3.1',
        title: 'חומר פתחי הגישה ועוביו חייבים להיות שווים לאלה של התעלה עצמה.',
        isTitle: false
      },
      {
        section: '7.4.3.2',
        title:
          'פתחי הגישה חייבים להיות מצוידים באטמים או בחומר איטום המדורג ל‑815.6°C (1,500ºF). על הלוחות להיות אטומים לשומן.',
        isTitle: false
      },
      {
        section: '7.4.3.3',
        title:
          'על קשיחי החיבור, דוגמת ברגים, חפי ריתוך, בריחים או אומי כנף, המשמשים להתקנת פתחי הגישה, להיות עשויים מפלדת פחמן או מפלב"ם. אסור על כל אלה לחדור דרך קיר התעלה.',
        isTitle: false
      },
      {
        section: '7.4.3.4',
        title:
          'יש להתקין את מכללי דלתות הגישה הרשומים לתעלת שומן (פתחי גישה) על פי תנאי האישור ובהתאם להוראות היצרן.',
        isTitle: false
      },
      {
        section: '7.4.4',
        title: 'הגנת פתחים',
        isTitle: true
      },
      {
        section: '7.4.4.1',
        title:
          'בתעלות ובעטיפות יש להתקין פתחים להתקנת מתקנים רשומים להגנה מאש, לטיפול במתקנים אלה, לביקורת עליהם ולניקוי התעלות. פתחים אלה חייבים לעמוד בדרישות סעיפים 7.3 ו‑7.7.4.',
        isTitle: false
      },
      {
        section: '7.4.4.2',
        title:
          'פתחי העטיפה הנדרשים במערכת התעלות כדי להגיע לפתחי הגישה חייבים להיות גדולים דיים כדי לאפשר את הסרת לוח הגישה דרכם.',
        isTitle: false
      },
      {
        section: '7.5',
        title:
          'תעלות שומן אחרות\nתעלות שומן אחרות חייבות לעמוד בדרישות סעיף זה.',
        isTitle: true
      },
      {
        section: '7.5.1',
        title: 'חומרים',
        isTitle: true
      },
      {
        section: '7.5.1.1',
        title:
          'יש לייצר את התעלות ואת התמיכות שלהן מפלדת פחמן בעובי של 1.5 מ"מ, לפחות, או מפלב"ם בעובי של 1.25 מ"מ, לפחות.',
        isTitle: false
      },
      {
        section: '7.5.1.2',
        title:
          'תעלות שומן המיוצרות במפעל ורשומות על פי תקן ANSI/UL 1978 יורשו להשתמש בחומרים המתאימים לאישור שלהן.',
        isTitle: false
      },
      {
        section: '7.5.2',
        title: 'התקנה',
        isTitle: true
      },
      {
        section: '7.5.2.1',
        title:
          'כל התפרים, החיבורים, החדירות וחיבורי הצווארון בין התעלה לבין המנדף חייבים להיות עשויים תפר ריתוך חיצוני רציף ואטום לנוזלים.',
        isTitle: false
      },
      {
        section: '7.5.2.1.1',
        title:
          'תעלות שומן המיוצרות במפעל הרשומות בהתאם ל - ANSI / UL 1978, יורשו לשלב חיבורים לא מרותכים בהתאם לרישום שלהם.',
        isTitle: false
      },
      {
        section: '7.5.2.1.2',
        title:
          'לפני השימוש או הסתרה של כל חלק ממערכת תעלות השומן, תבוצע בדיקת דליפה כדי לקבוע שכל המפרקים והתפרים המולחמים אטומים לנוזלים.\nהערה:\nאפשר שהבדיקה תהיה בדיקה חזותית בלבד',
        isTitle: false
      },
      {
        section: '7.5.2.2',
        title:
          'חיבורי הצווארון בין התעלה לבין המנדף, כפי שהם מוצגים באיור 7.5.2.2, אינם מחייבים תפר ריתוך חיצוני רציף ואטום לנוזלים.',
        isTitle: false
      },
      {
        section: '7.5.2.3',
        title:
          'מותר לאטום את החדירות באמצעות רכיבים רשומים אחרים אשר נבדקו ונמצאו אטומים לשומן. בחינת רכיבים אלה יש לבצע בתנאי עוצמת האש שבהם עמדו המנדף או עטיפה המתקנים להסרת השומן הרשומים. אסור על רכיבים אלה לפגוע במבנה המנדף או התעלה.',
        isTitle: false
      },
      {
        section: '7.5.2.4',
        title:
          'ריתוך פנימי מותר בתנאי שהחיבור הוא חלק, או הושחז לשם כך, ונגיש בנוחות לצורכי ביקורת.',
        isTitle: false
      },
      {
        section: '7.5.3',
        title: 'החדירות ייאטמו ברכיבים רשומים על פי דרישות סעיף 7.5.4.',
        isTitle: false
      },
      {
        section: '7.5.4',
        title:
          'מתקנים המחייבים חדירה של מערכת התעלות, כגון אבזרי/מהדקי צינורות ומוליכים, יירשמו על פי תקן ANSI/UL 1978.',
        isTitle: false
      },
      {
        section: '7.5.5',
        title: 'חיבורי תעלות מרותכים',
        isTitle: true
      },
      {
        section: '7.5.5.1',
        title:
          'חיבורים קבילים בין תעלות מפורטים להלן:\n(1) חיבור טלסקופי, כמוצג באיור 7.5.5.1 (א)\n(2) חיבור פעמון, כמוצג באיור 7.5.5.1 (ב)\n(3) ריתוך שולי אוגן, כמוצג באיור 7.5.5.1 (ג)\n(4) אוגן עם ריתוך מילוי, כמוצג באיור 7.5.5.1 (ד)',
        isTitle: false
      },
      {
        section: '7.5.5.2',
        title: 'אין להתיר חיבורי ריתוך השקה.',
        isTitle: false
      },
      {
        section: '7.5.5.3',
        title:
          'בחיבורים טלסקופיים ובחיבורי פעמון, קטע התעלה הפנימי חייב תמיד להיות גבוה מקטע התעלה החיצוני.',
        isTitle: false
      },
      {
        section: '7.5.5.4',
        title:
          'בחיבורים טלסקופיים ובחיבורי פעמון, אסור שההפרש בין הממדים הפנימיים של מקטעי החפיפה יעלה על 6.4 מ"מ (1/4 אינץ\').',
        isTitle: false
      },
      {
        section: '7.5.5.5',
        title:
          'בחיבורים טלסקופיים ובחיבורי פעמון, אסור שהחפיפה תעלה על 50.8 מ"מ (2 אינץ\').',
        isTitle: false
      },
      {
        section: '7.6',
        title: 'התקנות חיצוניות',
        isTitle: true
      },
      {
        section: '7.6.1',
        title:
          'ככל האפשר, יש להתקין את חלקה החיצוני של מערכת התעלות בכיוון אנכי ולתמוך בה על גבי הקיר החיצוני של הבניין.',
        isTitle: false
      },
      {
        section: '7.6.2',
        title:
          'אומים, ברגים, מסמרות ומהדקים מכניים אחרים לא יחדרו דרך קירות התעלות.',
        isTitle: false
      },
      {
        section: '7.6.3',
        title: 'על מרווחי כל התעלות לעמוד בהוראות סעיף 4.2.',
        isTitle: false
      },
      {
        section: '7.6.4',
        title:
          'על שטחם החיצוני של כל התעלות יש להגן מפני השפעות מזג האוויר בצביעה או בציפוי מתאים אחר.',
        isTitle: false
      },
      {
        section: '7.6.5',
        title:
          'תעלות המיוצרות מפלב"ם אינן נדרשות לצביעה נוספת או לציפוי אחר להגנה מפני השפעות מזג האוויר.',
        isTitle: false
      },
      {
        section: '7.6.6',
        title:
          'במערכת תעלות החשופה לשיתוך יש לצמצם למינימום את שטח המגע בינה לבין פני הבניין.',
        isTitle: false
      },
      {
        section: '7.7',
        title: 'התקנות פנימיות',
        isTitle: true
      },
      {
        section: '7.7.1',
        title: 'עטיפות תעלות',
        isTitle: true
      },
      {
        section: '7.7.1.1',
        title:
          'בכל הבניינים שבהם קיימת חדירה דרך מחסומי אש אנכיים, על התעלות להיות מוקפות בעטיפה רציף המשתרע ממחסום האש הראשון שבו קיימת החדירה, דרך מחסומי אש או חללים מוסתרים עוקבים, עד מחוץ לבניין או דרך הצד החיצוני שלו. זאת, כדי לשמור על דירוג עמידות לאש של המחסום הגבוה ביותר שבו קיימת החדירה.',
        isTitle: false
      },
      {
        section: '7.7.1.2',
        title:
          'בכל הבניינים שגובהם עולה על קומה אחת ובבניינים בעלי קומה אחת, שבהם מכלל הגג‑תקרה מחייב דירוג אש, יש לכלוא את התעלות בעטיפה רציף המשתרע מן התקרה/הרצפה הנמוכה ביותר, מעל המנדף, המחייבת דירוג אש, וכן דרך חללים מוסתרים כלשהם לעבר הגג או דרכו. זאת, כדי לשמור על שלמות הפרדות האש הנדרשות על פי תנאי תקנות הבנייה הישימות.',
        isTitle: false
      },
      {
        section: '7.7.1.3',
        title:
          'יש לאטום את העטיפה סביב התעלה בנקודת החדירה של מחסום האש הראשון אחרי המנדף. זאת, כדי להבטיח את דירוג העמידות לאש של העטיפה.',
        isTitle: false
      },
      {
        section: '7.7.1.4',
        title:
          'יש לאוורר את העטיפה אל מחוץ לבניין דרך פתחים המוגנים מפני השפעות מזג האוויר.',
        isTitle: false
      },
      {
        section: '7.7.1.5',
        title:
          'ההוראות לגבי עטיפה רציף אינן נדרשות כאשר עטיפה תעלת השומן המיושם בשטח או המיוצר במפעל (ראה סעיף 4.3) מוגן במערכת רשומה להגנת חדירה של תעלה. דירוג העמידות לאש של המערכת חייב להיות שווה לזה של המכלל שבו קיימת החדירה, וזאת כאשר התקנת החומרים מבוצעת על פי תנאי האישור, בהתאם להוראות היצרן והיא קבילה על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '7.7.2',
        title: 'דירוג עמידות האש של עטיפה ומרווח העטיפה',
        isTitle: true
      },
      {
        section: '7.7.2.1.1',
        title:
          'בניינים שגובהם פחות מארבע קומות חייבים בעטיפה בעל דירוג עמידות לאש שאינו נמוך משעה אחת.',
        isTitle: false
      },
      {
        section: '7.7.2.1.2',
        title:
          'בניינים שגובהם ארבע קומות ויותר חייבים בעטיפה בעל דירוג עמידות אש שאינו נופל משעתיים.',
        isTitle: false
      },
      {
        section: '7.7.2.2.1',
        title:
          'אסור שהמרווח בין התעלה או מאוורר הפליטה לבין שטחם הפנימי של עטיפות מבנה בעיר, יהיה קטן מ‑457 מ"מ (18 אינץ\').',
        isTitle: false
      },
      {
        section: '7.7.2.2.2',
        title:
          'אסור שהמרווח בין התעלה או מאוורר הפליטה לבין שטחם הפנימי של עטיפות מבנה לא בעיר או בעיר באופן מוגבל יהיה קטן מ‑152 מ"מ (6 אינץ\').\nבמקרים שבהם מכלל מעטפת תעלת המנדף עומד בדרישות התקן הישראלי ת"י 931 (על חלקיו), והחומר שממנו בנוי חלקו הפנימי של הפיר הוא לא דליק (ראו הגדרה 3.3.37.3).',
        isTitle: false
      },
      {
        section: '7.7.2.2.4',
        title:
          'מותר לצמצם את המרווח בין שטחם החיצוני של עטיפות תעלות השומן המיושמים בשטח ועטיפות כאלה המיוצרים במפעל לבין שטחם הפנימי של המבנים המקיפים אותם, וזאת כאשר החומרים של עטיפות תעלות השומן המיושמים בשטח ואלה המיוצרים במפעל מותקנים על פי תנאי האישור ובהתאם להוראות היצרן, וכן הם קבילים על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '7.7.2.2.5',
        title:
          'עטיפות תעלות השומן המיושמים בשטח ועטיפות תעלות שומן המיוצרים במפעל חייבים להבטיח שלמות מכנית ומבנית, גמישות ויציבות כשהם נחשפים לתנאי הסביבה האמורים להתקיים בבניין, לתנועת התעלה בתנאי הפעלה רגילים ולתנועת התעלה בתנאי שריפה פנימית וחיצונית.',
        isTitle: false
      },
      {
        section: '7.7.3',
        title: 'הגנה על  כיסויים וחומרי עטיפה / פירים',
        isTitle: true
      },
      {
        section: '7.7.3.1',
        title: 'יש לבצע מדידות כדי למנוע נזק פיזי לחומר כיסוי או לחומר העטיפה.',
        isTitle: false
      },
      {
        section: '7.7.3.2',
        title:
          'יש לתקן כל נזק לכיסוי או לעטיפה ויש להחזירם למצב שבו הם עומדים בתנאי האישור ובדירוג העמידות לאש, כאשר התיקון קביל על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '7.7.3.3',
        title:
          'במקרה של שריפה בתוך מערכת הפליטה של מטבח, עובד מוסמך הוא שיבדוק את התעלה, העטיפה או הכיסוי הישיר של התעלה, ועליו לוודא כי התעלה, העטיפה וכיסוי התעלה תקינים מבחינה מבנית, יכולים למלא את תפקידם בהגנה מאש, כשירים להמשך הפעלה, וכן הם קבילים על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '7.7.3.4',
        title:
          'יש להתקין את מכללי המנדפים הרשומים על פי תנאי האישור ובהתאם להוראות היצרן.',
        isTitle: false
      },
      {
        section: '7.7.4',
        title: 'פתחי עטיפה / פירים',
        isTitle: true
      },
      {
        section: '7.7.4.1',
        title:
          'כאשר בקירות העטיפה מותקנים פתחים, עליהם להיות מוגנים באמצעות דלתות אש רשומות בעלות דירוג מתאים.',
        isTitle: false
      },
      {
        section: '7.7.4.2',
        title: 'יש להתקין את הדלתות על פי תקן ת"י 1212 - דלתות אש: עמידות אש.',
        isTitle: false
      },
      {
        section: '7.7.4.3',
        title:
          'פתחים העשויים מחומרים רשומים או ממוצרים רשומים אחרים חייבים בזיהוי ברור ובתיוג על פי תנאי האישור ובהתאם להוראות היצרן, וכן עליהם להיות קבילים על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '7.7.4.3.1',
        title:
          'הסימון המצוין בסעיף 7.7.4.3 יהיה גלוי לעין בצדו החיצוני של העטיפה יציין את הדבר הבא:\nACCESS PANEL — DO NOT OBSTRUCT\nנוסף על נוסח השלט באנגלית, ייכתב השלט גם בעברית, כמפורט להלן:\nפתח גישה - אסור לחסום\nגודל האותיות יהיה 25 מ"מ, צבען יהיה אדום והן יופיעו על רקע לבן.',
        isTitle: false
      },
      {
        section: '7.7.4.4',
        title:
          'דלתות האש חייבות להיות נגישות בנוחות, ממוקמות היטב, ובעלות ממדים מספיקים המאפשרים גישה לפתחי הגישה העמידים באש המותקנים במערכת התעלות.',
        isTitle: false
      },
      {
        section: '7.7.5',
        title: 'תעלות בעלות עטיפה(ים) / פירים',
        isTitle: true
      },
      {
        section: '7.7.5.1',
        title:
          'על כל מערכת תעלות להוות מערכת בדידה ולהעניק שירות רק למנדפי פליטה באזור אש אחד ובקומה אחת.',
        isTitle: false
      },
      {
        section: '7.7.5.2',
        title: 'אין להתיר תעלות מרובות בעטיפה יחידה.',
        isTitle: false
      },
      {
        section: '7.7.5.2.1',
        title:
          'למרות האמור לעיל, מותר להעביר באותו פיר עד 4 תעלות מנדף מאזורי אש שונים.\nמהתעלה ה 5- ומעלה, התעלות יהיו מבודדות זו מזו בחומר המבטיח עמידות אש כמפורט להלן:\n- שעה אחת לפחות בכל אמות המידה, בבניין שיש בו עד 4 קומות;\n- 2 שעות לפחות בכל אמות המידה, בבניין שיש בו יותר מ -4 קומות.',
        isTitle: false
      },
      {
        section: '7.7.5.2.2',
        title:
          'בדיקת עמידות האש תיערך לפי התקן הישראלי ת"י 931 חלק 1 בחלק (העשרוני) הרלוונטי.',
        isTitle: false
      },
      {
        section: '7.7.5.2.3',
        title:
          'ביישום הגנה מפני אש לתעלות תוך שימוש בלוחות גבס:\n* בתכנון ההנדסי יובאו בחשבון הדרישות המפורטות בתקן הישראלי ת"י 1924 לפחות;\n* יישום הגנה מפני אש לתעלות יהיה לפי התקן הישראלי ת"י 1924.',
        isTitle: false
      },
      {
        section: '7.7.5.2.4',
        title:
          'ביישום הגנה מפני אש לתעלות, היישום ייבדק וייושם לפי התקן האמריקני ASTM E2336 וכל יישום העונה להגדרות פיר עמיד אש לפי תקן זה (ת"י 1001 חלק 6) ייבדק לפי התקן הישראלי ת"י 931 (על חלקיו).\nהערה לאומית:\nסעיף זה (7.7.5.2.4) ייכנס לתוקף שנה מיום פרסום תקן ישראלי זה ב"רשומות".',
        isTitle: false
      },
      {
        section: '7.7.5.2.5',
        title:
          'יישום פתח השירות יאפשר פתיחה וסגירה לצורכי אחזקה ללא פגיעה בציפוי.',
        isTitle: false
      },
      {
        section: '7.7.5.2.6',
        title:
          'ניתן ליישם אלמנטים שנבדקו אנכית גם במצב אופקי או בשיפוע לפי המפורט בתקן הישראלי ת"י 931 חלק 1.3 , בסעיף הדן ב- Specimen orientation (סעיף 3.9).\nהיישום מחייב ביצוע חישובים הנדסיים המביאים בחשבון את העומסים הנוצרים עקב שינוי בתנוחה בטמפרטורת הסביבה.',
        isTitle: false
      },
      {
        section: '7.8',
        title: 'סיומת מערכת פליטה',
        isTitle: true
      },
      {
        section: '7.8.1',
        title:
          'סיומת מערכת הפליטה תהיה כדלקמן:\n(1)* מחוץ לבניין עם מאוורר או תעלה\n(2) דרך הגג או לעברו מבחוץ על פי האמור בסעיף 7.8.2, או דרך הקיר על פי האמור בסעיף 7.8.3',
        isTitle: false
      },
      {
        section: '7.8.2.1',
        title:
          "סיומות ראש גג יהיו נתונות לדרישות הבאות:\n(1) פתח הפליטה חייב להיות במרחק אופקי מזערי של 3 מטר (10 רגל) מן הבניינים הסמוכים, מגבולות הנכס ומפתחי כניסת האוויר\n(2) פתח הפליטה (תיבת המאוורר) חייב להיות במרחק אופקי מזערי של 1.5 מטר (5 רגל) מכל מבנה בעיר\n(3) פתחי כניסת האוויר חייבים להיות במרחק אנכי של 0.92 מטר (3 רגל) מתחת לפתחי פליטה כלשהם ובמרחק של 3 מטר (10 רגל) מפתח הפליטה\n(4) יש להבטיח אפשרות לנקז שומן מכל המלכודות או מכל הנקודות הנמוכות של מאוורר או תעלה בסמוך לסיומת מערכת, והוא ינוקז לתוך מכל איסוף לא בעיר, סגור, עמיד בגשם ובנוי היטב למטרה אשר לה הוא מיועד בלא להזין בעירה.\n(5) אסור שמכל לאיסוף השומן המותקן במערכות פליטה יפגע בביצועים של מאוורר כלשהו\n(6) מערכות איסוף שומן רשומות העומדות בדרישות סעיפים 7.8.2.1(4) ו 7.8.2.1(5) \n(7) תעלת שומן רשומה העומדת בדרישות סעיף 4.4, או מערכת תעלות העומדת בדרישות סעיף 4.5\n(8) מאוורר דוחף מעלה צירי יסופק עם כבל חשמלי גמיש ועמיד להשפעות מזג האוויר ובמנגנון פתיחה המאפשר ביקורת וניקוי. מאוורר כזה יהיה רשום לשימוש עם ציוד בישול מסחרי בכפוף לתנאים הבאים:\n   (א) במקום שהמאוורר מחובר למערכת התעלות, מערכת זו חייבת להיות במרחק מזערי של 0.46 מטר (18 אינץ') מכל קטע של שטח הגג, כמוצג באיור 7.8.2.1.\n   (ב) על המאוורר לפלוט את האוויר במרחק מזערי של 1.02 מטר (40 אינץ') מכל קטע של שטח הגג, כמוצג באיור 7.8.2.1.\n(9) אפשר להתקין מאוורר מאושר אחר ובלבד:\n   (א) שהוא עומד בדרישות סעיפים 7.8.2.1(3) ו 8.1.4.\n   (ב) שהפליטה שלו, או הפליטה מתעלת ההארכה שלו, עומדת בדרישות סעיף 7.8.2.1(2). (ראה 8.1.4.)\n   (ג) שהפליטה שלו תהיה מכוונת כלפי מעלה, הרחק ממשטח הגג.",
        isTitle: false
      },
      {
        section: '7.8.2.2',
        title: 'יש להבטיח גישה בטוחה ובמת עבודה לבדיקת המאוורר ולניקויו.',
        isTitle: false
      },
      {
        section: '7.8.3',
        title:
          'סיומות קיר. סיומות קיר יהיו נתונות לדרישות הבאות:\n(1) פתח היציאה העובר דרך קיר לא בעיר חייב להיות במרחק מזערי של 3 מטר (10 רגל) מבניינים סמוכים, מגבולות הנכס, ממפלס הקרקע, ממבנה בעיר, מציוד/קווי חשמל, מהנקודה הקרובה ביותר של כל פתח כניסת אוויר ומכל דלת/חלון שימושיים במישור האופקי של סיומת הפליטה או מתחתיו.\n(2) הנקודה הקרובה ביותר של כל פתח כניסת אוויר או דלת/חלון שימושיים מעל המישור האופקי של סיומת הפליטה חייבת להיות במרחק מזערי של 3 מטר (10 רגל) + 76 מ"מ (3 אינץ\') לכל מעלת סטייה מן המישור האופקי, וזווית הסטייה תימדד ממרכז פתח הפליטה אל מרכז פתח כניסת האוויר או הדלת/החלון השימושיים – כמצוין באיור 7.8.3.\n(3) סיומת קיר באזור מאובטח יכולה להיות בגובה פחות מעל מישור הקרקע, אם הדבר קביל על ידי הרשות המוסמכת.\n(4) זרם הפליטה יופנו החוצה בניצב לקיר או כלפי מעלה.\n (5) על מערכת התעלות להיות מוטה כדי לנקז את השומן חזרה לתוך המנדפים, ולחלופין עליה להיות מצוידת בניקוז המחזיר את השומן לתוך מכל בתוך הבניין או לתוך מלכודת שומן מרוחקת.\n(6) תעלת שומן רשומה חייבת לעמוד בהוראות סעיף 7.4. על תעלות אחרות לעמוד בהוראות סעיף 7.5.\n(7) מאוורר מאושר חייב לעמוד בדרישות סעיפים 7.8.3(5) ו 8.1.1 או 8.1.3.',
        isTitle: false
      },
      {
        section: '7.8.4.1',
        title:
          'מערכת תעלות אש יוצאת מהבניין דרך קיר בעיר או בעיר באופן מוגבל ומסתיימת מעל קו הגג חייבת בקיר מגן המותקן בהתאם להוראות סעיף 4.2.',
        isTitle: false
      },
      {
        section: '7.8.4.2',
        title:
          'פתח שדרכו מערכת התעלות יוצאת מן הבניין חייב להיות אטום, מאוורר, ומוגן מזג אוויר.',
        isTitle: false
      },
      {
        section: '7.8.4.3',
        title:
          'במקום שמערכת התעלות יוצאת דרך קיר עמיד אש, על החדירה להיות מוגנת על פי סעיף 4.4.1.',
        isTitle: false
      }
    ]
  },
  {
    section: '8',
    title: 'תנועת אוויר',
    isTitle: true,
    subCases: [
      {
        section: '8.1',
        title: 'מאווררי פליטה לציוד בישול מסחרי',
        isTitle: true
      },
      {
        section: '8.1.1',
        title:
          'מאווררים המשמשים במערכות פליטה לבישול מסחרי נדרשים להיות רשומים בהתאם לת"י 1001 חלק 7.',
        isTitle: false
      },
      {
        section: '8.1.2',
        title: 'מאווררי פליטה דוחפים מעלה',
        isTitle: true
      },
      {
        section: '8.1.2.1',
        title:
          'מאווררים דוחפים מעלה בעלי מנוע המוקף זרם אוויר יותקנו על ציר, יהיו תלויים ויסופקו עם כבל חשמלי גמיש ועמיד להשפעות מזג האוויר ויהיו מצוידים במנגנון  השומר אותם במצב פתוח.',
        isTitle: false
      },
      {
        section: '8.1.2.2',
        title: 'יש לבצע את התקנת המאוורר בהתאם לדרישות סעיף 7.8.',
        isTitle: false
      },
      {
        section: '8.1.2.3',
        title:
          "מאווררים דוחפים מעלה חייבים להיות בעלי נקז המכוון למכל שומן נגיש בקלות וגלוי לעין שלא יעלה על 3.8 ל' (1 גלון).",
        isTitle: false
      },
      {
        section: '8.1.2.4',
        title:
          "המפוחים ייבדקו בבדיקת תפעול, בטמפרטורה של 250 מעלות צ' לפחות.\nהמפוחים יפעלו פעולה תקינה במשך שעה אחת לפחות, בתנאי הבדיקה.",
        isTitle: false
      },
      {
        section: '8.1.3',
        title: 'מאווררי פליטה מוכללים',
        isTitle: true
      },
      {
        section: '8.1.3.1',
        title:
          'מנועי המאווררים המוכללים חייבים להיות ממוקמים מחוץ לזרם האוויר. על המאוורר להיות מצויד ברצועות ובגלגלות המוגנות מפני זרם האוויר על ידי עטיפה אטום לשומן.',
        isTitle: false
      },
      {
        section: '8.1.3.2',
        title:
          'המאווררים המוכללים יחוברו לתעלת פליטה באוגנים בעלי חיבור חזק בברגים, כמוצג באיורים 8.1.3.2(א) עד 8.1.3.2(ד), ולחלופין אפשר להשתמש במערכת הרשומה ספציפית לשימוש זה.',
        isTitle: false
      },
      {
        section: '8.1.3.3',
        title: 'אין להשתמש במחברים גמישים.',
        isTitle: false
      },
      {
        section: '8.1.3.4',
        title:
          "כאשר תכנון המאוורר או מיקומו מאפשרים לכידת שומן, יש להתקין ניקוז המופנה למכל נגיש בנוחות, נראה לעין, ובעל קיבולת שאינה עולה על 3.8 ל' (1 גלון).",
        isTitle: false
      },
      {
        section: '8.1.3.5',
        title:
          'יש למקם את מאווררי הפליטה המוכללים באזור נגיש בנוחות, בעל ממדים המאפשרים טיפול והסרה.',
        isTitle: false
      },
      {
        section: '8.1.3.6',
        title:
          'כאשר החיבור בין מערכת התעלות לבין המאוורר סגור בעטיפה, החלל או החדר שבו ממוקם מאוורר הפליטה חייב בבמקום שג עמידות לאש השווה לזו של העטיפה.',
        isTitle: false
      },
      {
        section: '8.1.3.7',
        title:
          "המפוחים ייבדקו בבדיקת תפעול, בטמפרטורה של 250 מעלות צ' לפחות.\nהמפוחים יפעלו פעולה תקינה במשך שעה אחת לפחות, בתנאי הבדיקה.",
        isTitle: false
      },
      {
        section: '8.1.4',
        title: 'מאווררי פליטה צינטריפוגליים',
        isTitle: true
      },
      {
        section: '8.1.4.1',
        title:
          'מאווררי פליטה עצמאיים המותקנים בנקודת סיום בראש גג חייבים לעמוד בדרישות סעיפים 7.8.2.1(1) עד 7.8.2.1(3) ו‑7.8.2.2.',
        isTitle: false
      },
      {
        section: '8.1.4.2',
        title:
          'מאווררים המותקנים בתוך הבניין ימוקמו בשטח נגיש בגודל מתאים כדי לאפשר שירות או הסרה.',
        isTitle: false
      },
      {
        section: '8.1.4.3',
        title:
          'כאשר החיבור בין מערכת התעלות לבין המאוורר סגור בעטיפה, החלל או החדר שבו ממוקם מאוורר הפליטה חייב בדירוג עמידות לאש השווה לזו של העטיפה.',
        isTitle: false
      },
      {
        section: '8.1.4.4',
        title:
          'המאוורר יחובר לתעלת פליטה באמצעות אוגנים המהודקים בברגים, כמוצג באיורים 8.1.3.2(א) עד 8.1.3.2(ד), ולחלופין אפשר להשתמש במערכת הרשומה ספציפית לשימוש זה.',
        isTitle: false
      },
      {
        section: '8.1.4.5',
        title: 'אין להשתמש במחברים גמישים.',
        isTitle: false
      },
      {
        section: '8.1.4.6',
        title:
          "מאווררי פליטה חייבים להיות בעלי נקז המכוון למכל שומן נגיש בקלות וגלוי לעין שלא יעלה על 3.8 ל' (1 גלון).",
        isTitle: false
      },
      {
        section: '8.1.4.7',
        title:
          "המפוחים ייבדקו בבדיקת תפעול, בטמפרטורה של 250 מעלות צ' לפחות.\nהמפוחים יפעלו פעולה תקינה במשך שעה אחת לפחות, בתנאי הבדיקה.",
        isTitle: false
      },
      {
        section: '8.1.5',
        title:
          'תיבות מאווררי פליטה \nתיבות מאווררי הפליטה ייבנו מפלדת פחמן בעובי מזערי של 1.5 מ"מ, או מפלב"ם בעובי מזערי של 1.25 מ"מ , ולחלופין אם התיבה רשומה, היא תיבנה על פי תנאי האישור.',
        isTitle: false
      },
      {
        section: '8.1.6.3',
        title: 'מאווררים דוחפים מעלה.',
        isTitle: true
      },
      {
        section: '8.1.6.3.1',
        title:
          'יש לספק מאווררים דוחפים מעלה עם פתח גישה בגודל של לפחות 76 מ"מ על 127 מ"מ (3 אינץ\' × 5 אינץ\') או בקוטר מעגלי של 101 מ"מ (4 אינץ\') על האזור הקמור של תיבת המאוורר החיצוני במטרה לאפשר ניקוי וביקורת של להבי המאוורר.',
        isTitle: false
      },
      {
        section: '8.1.6.3.2',
        title:
          'במאווררים דוחפים מעלה קיימים שאין בהם גישה מספקת כדי לאפשר את הסרת זיהום השומן, חובה להתקין מנגנון צירי או פתח גישה מאושר.',
        isTitle: false
      },
      {
        section: '8.1.7',
        title:
          'חיווט וציוד חשמלי\nעל כל החיווט והציוד החשמלי לעמוד בהוראות חוק החשמל הישראלי התשי"ד-1954 על תקנותיו ועדכוניהם (ראה גם פרק 9).',
        isTitle: false
      },
      {
        section: '8.2',
        title: 'זרם אוויר',
        isTitle: true
      },
      {
        section: '8.2.1',
        title: 'מהירות אוויר',
        isTitle: true
      },
      {
        section: '8.2.1.1',
        title:
          "אסור שמהירות האוויר העובר דרך תעלה כלשהי תהיה נמוכה מ‑152.4 מ'/דק' - 2.54 מ'/שנ' (500 רגל/דק').",
        isTitle: false
      },
      {
        section: '8.2.1.2',
        title:
          'קטעי המעבר של תעלות שאורכם אינו מעל 0.92 מטר (3 רגל), ואין בהם מלכודות שומן יאושרו להתחבר למנדפים ולמאווררי פליטה שאינם עומדים במהירות הנקובה לעיל',
        isTitle: false
      },
      {
        section: '8.2.2',
        title: 'נפח אוויר',
        isTitle: true
      },
      {
        section: '8.2.2.1',
        title:
          'נפח האוויר הנפלט ממנדפים יספיק ללכידת אדי הבישול נושאי השומן ולהסרתם.',
        isTitle: false
      },
      {
        section: '8.2.2.2',
        title:
          'יש לספק ו/או להציג על פי הנדרש את נתוני הבדיקות ו/או תיעוד הביצועים הקבילים לידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '8.2.2.3',
        title:
          'נפח אוויר פליטה קטן יותר מותר במצב של העדר עומס בישול, ובלבד שיש בו כדי ללכוד ולהסיר את גזי הארובה ואת האדים השיוריים הנפלטים מציוד הבישול.',
        isTitle: false
      },
      {
        section: '8.2.3',
        title: 'פעולת מאוורר פליטה',
        isTitle: true
      },
      {
        section: '8.2.3.1',
        title:
          'אחרי הפעלת מערכת כיבוי האש, על מאווררי הפליטה של המנדף להמשיך ולפעול אלא אם השבתת המאוורר נדרשת על ידי רכיב רשום של מערכת האוורור או על ידי תכנון מערכת כיבוי האש.',
        isTitle: false
      },
      {
        section: '8.2.3.2',
        title:
          'מאוורר הפליטה יופעל עם הפעלת מערכת הכיבוי אם מאוורר הפליטה וכל ציוד הבישול המשורתים על ידי המאוורר נסגרים, אלא אם כן נדרשת סגירה של המאוורר על ידי רכיב רשום של מערכת האוורור או על ידי הרישום של מערכת הכיבוי.',
        isTitle: false
      },
      {
        section: '8.2.3.3',
        title:
          'למאוורר הפליטה יסופק אמצעי כך שהמאוורר יפעל במידה וישנו מכשיר בישול המייצר חום פועל מתחת למנדף.',
        isTitle: false
      },
      {
        section: '8.2.3.4',
        title:
          'המפוח יחובר למקור כוח חלופי (גנרטור) לצורך הפעלתו בזמן הפסקה באספקת החשמל אליו.\nהדרישה חלה רק על מפוחים המותקנים בבניינים שקיים בהם גנרטור המייועד להפעלת מערכות חירום בזמן שריפה.',
        isTitle: false
      },
      {
        section: '8.3',
        title: 'אוויר מחליף',
        isTitle: true
      },
      {
        section: '8.3.1',
        title:
          "כמות האוויר המחליף חייבת להספיק כדי למנוע לחצים שליליים מעל 4.98 Pa (0.02 אינץ' של עמודת מים) באזורי הבישול המסחריים.",
        isTitle: false
      },
      {
        section: '8.3.2',
        title:
          'כאשר מערכת כיבוי האש מופעלת, על הספקת האוויר המחליף הפנימית למנדף להיות סגורה.',
        isTitle: false
      },
      {
        section: '8.4',
        title: 'מערכות תעלה משותפות (סעפת)',
        isTitle: true
      },
      {
        section: '8.4.1',
        title:
          'תעלות הפליטה הראשיות של המטבח, המשרתות שוכרים רבים, חייבות להיות מצוידות במתקן לשאיבת אוויר מבחוץ, או מחללים סמוכים, לתוך תעלת הפליטה הראשית, היכן שנדרש לשמור על מהירות האוויר המזערית בתעלת הפליטה הראשית.',
        isTitle: false
      },
      {
        section: '8.4.2',
        title:
          'יש לחבר את תעלות האוויר הנשאב לצדה העליון או הצדדי של תעלת הפליטה הראשית.',
        isTitle: false
      },
      {
        section: '8.4.3',
        title:
          'תעלת האוויר הנשאב תהיה מצוידת במדף (Dumper) אש במרחק 304.8 מ"מ (12 אינץ\') לפחות מהחיבור לתעלת הפליטה.',
        isTitle: false
      },
      {
        section: '8.4.4',
        title:
          'החל בחיבור לתעלת הפליטה ועד 304.8 מ"מ (12 אינץ\') לפחות, משני צדי מדף (Dumper) האש, תעלת האוויר הנשאב תהיה כפופה לדרישות המבנה והמרווחים החלות על תעלת הפליטה הראשית.',
        isTitle: false
      },
      {
        section: '8.4.5',
        title:
          'כל תעלת אוויר נשאב תהיה מצוידת באמצעי לוויסות כמות האוויר הנשאב (לדוגמה, מדפי נפח).',
        isTitle: false
      },
      {
        section: '8.4.6',
        title:
          'יש להתקין את האמצעי לוויסות כמות האוויר הנשאב בין מדף (Dumper) האש לבין מקור האוויר הנשאב.',
        isTitle: false
      },
      {
        section: '8.4.7',
        title:
          'אין להשתמש בתעלת האוויר הנשאב לפליטת אדים נושאי שומן. חובה לתייגן בהתאם.',
        isTitle: false
      },
      {
        section: '8.4.8',
        title:
          'יש לנתק ולאטום ליד התעלה הראשית את החיבורים לתעלת הפליטה הראשית של שוכרים שאינם משתמשים בהם לשאיבת האוויר.',
        isTitle: false
      }
    ]
  },
  {
    section: '9',
    title: 'ציוד עזר',
    isTitle: true,
    subCases: [
      {
        section: '9.1',
        title: 'מדפים (Dumpers)',
        isTitle: true
      },
      {
        section: '9.1.1',
        title: 'אין להתקין דמפרים בתעלות פליטה או במערכות של תעלות פליטה.',
        isTitle: false
      },
      {
        section: '9.1.2',
        title:
          'התקנת דמפרים בתעלות פליטה או במערכות של תעלות פליטה מותרת, כאשר הדמפרים רשומים ספציפית לשימוש זה, או כשהם נדרשים כחלק ממתקן רשום או ממערכת רשומה.',
        isTitle: false
      },
      {
        section: '9.2',
        title: 'ציוד חשמלי',
        isTitle: true
      },
      {
        section: '9.2.1',
        title: 'אין להתקין בתעלות מערכות חיווט כלשהן.',
        isTitle: false
      },
      {
        section: '9.2.2',
        title:
          'בתוך תעלות, או מנדפים, או בנתיב תנועת תוצרי הפליטה, מותר להתקין מנועים, נורות ומתקני חשמל אחרים, רק בתנאי שהם רשומים ספציפית לשימוש כזה.',
        isTitle: false
      },
      {
        section: '9.2.3',
        title: 'יחידות תאורה',
        isTitle: true
      },
      {
        section: '9.2.3.1',
        title:
          'יחידות תאורה למנדפים חייבות להיות רשומות לשימוש מעל מכשירי בישול מסחריים, וחובה להתקין אותן על פי הוראות האישור.',
        isTitle: false
      },
      {
        section: '9.2.3.2',
        title:
          'אין למקם את יחידות התאורה בחללים מוסתרים של המנדפים למעט כפי שהותר בסעיפים 9.2.3.3 ו‑9.2.3.4.',
        isTitle: false
      },
      {
        section: '9.2.3.3',
        title:
          'מותר למקם את יחידות התאורה בחללים מוסתרים כאשר יחידות אלה הן חלק ממנדף פליטה רשום.',
        isTitle: false
      },
      {
        section: '9.2.3.4',
        title:
          'מותר להתקין את יחידות התאורה הרשומות בחללים מוסתרים כאשר תנאי האישור מתירים ספציפית התקנה כזו והם מותקנים על פי תנאי האישור.',
        isTitle: false
      },
      {
        section: '9.2.4',
        title:
          'יש להתקין את כל הציוד החשמלי על פי חוק החשמל הישראלי התשי"ד-1954 על תקנותיו ועדכוניהם.',
        isTitle: false
      },
      {
        section: '9.3',
        title: 'ציוד אחר',
        isTitle: true
      },
      {
        section: '9.3.1',
        title:
          'מותר להתקין בתעלות או במנדפים, או בנתיב תנועת תוצרי הפליטה, כבשני עשן, יחידות למחזור אנרגיית חום, מתקנים לבקרת זיהום האוויר או מתקנים אחרים, ובלבד שכל אלה מאושרים ספציפית לשימוש זה.',
        isTitle: false
      },
      {
        section: '9.3.1.1',
        title:
          'כבשני עשן, יחידות למחזור אנרגיית חום, מתקנים לבקרת זיהום האוויר ו/או מתקנים אחרים המותקנים בתעלות או במנדפים יעמדו בדרישות הבאות:\n(1) דרישות המרווחים של סעיף 4.2\n(2) דרישות מבנה המנדף בסעיף 5.1\n(3) מבנה תעלת הפליטה יעמוד בדרישות פרק 7\n(4) ציוד אחר המותקן במנדף יעמוד בדרישות הפעלה בו זמנית בסעיף 10.3.1\n(5) ציוד אחר המותקן בתעלה יעמוד בדרישות סעיף 10.1.3\n(6) פתחי גישה או דלתות יעמדו בדרישות פרק 7\n(7) מאווררים מוכללים תואמי סעיף 8.1.3.1',
        isTitle: false
      },
      {
        section: '9.3.1.2',
        title:
          'ציוד הרשום למרווחים מופחתים חייב להיות רשום על פי תקן ANSI/UL 1978.',
        isTitle: false
      },
      {
        section: '9.3.1.3',
        title:
          'יש לשמור על מרווח בין הציוד לבין כל פתחי הגישה או הדלתות לצורך הסרה וטיפול בטוחים בהתקני בקרה, כגון מסננים, תאי משקעים אלקטרוסטטיים ומצעים סופחי ריח, וכן לצורך ניקוי תיבות הציוד',
        isTitle: false
      },
      {
        section: '9.3.2',
        title:
          'אסור שהתקנת המתקנים המאושרים האמורים, בין אם הם רשומים ובין אם לאו, תפגע ברכיבים אחרים של מערכת הפליטה.',
        isTitle: false
      },
      {
        section: '9.3.3',
        title:
          'כל ציוד, המטפל בסינון משני או בבקרת זיהום האוויר והמותקן בנתיב תנועת תוצרי הפליטה, חייב להיות מצויד במערכת כיבוי אש אוטומטית ומאושרת, שהותקנה על פי הוראות יצרן המערכת.\nבציוד שלא ניתן להגן עליו, הציוד יותקן באזור אש נפרד.\nעמידות האש של קירות ההפרדה באזור האש תהיה זהה לעמידות האש הנדרשת מהמעטפת לפחות לפי סעיפים 7.7.2.1.1 ו- 7.7.2.1.2.',
        isTitle: false
      },
      {
        section: '9.3.3.1',
        title:
          'מערכת כיבוי האש הנדרשת על ידי 9.3.3 תספק הגנה על חלקי המרכיבים של הציוד, והתעלות במורד הציוד.',
        isTitle: false
      },
      {
        section: '9.3.3.2',
        title:
          'חומרי סינון המשמשים בסינון משני או ביחידות בקרת זיהום אוויר ולא עומדים בדרישות 6.2.3 יהיו בעלי הגנת אש המתאימה למסנן שבשימוש בהתאם להנחיות יצרן מערכת כיבוי האש.',
        isTitle: false
      },
      {
        section: '9.3.4',
        title:
          'כאשר הציוד כולל מקור הצתה, עליו להיות מצויד במערכת גילוי להפעלת מערכת כיבוי האש המגנה על הציוד.',
        isTitle: false
      }
    ]
  },
  {
    section: '10',
    title: 'ציוד כיבוי אש',
    isTitle: true,
    subCases: [
      {
        section: '10.1',
        title: 'דרישות כלליות',
        isTitle: true
      },
      {
        section: '10.1.1',
        title:
          'יש לספק ציוד כיבוי אש להגנה על מתקנים להסרת שומן, תאי אוויר (פלנום) פליטה של מנדפים ומערכות תעלות הפליטה.',
        isTitle: false
      },
      {
        section: '10.1.2',
        title:
          'ציוד בישול, המפיק אדים נושאי שומן והעלול להיות מקור הצתה לשומן בתוך המנדף, בתוך המתקן להסרת השומן או בתוך התעלה, חייב בהגנת ציוד כיבוי אש.',
        isTitle: false
      },
      {
        section: '10.1.3',
        title:
          'כבשן אדים, יחידות התאוששות תרמית, התקני בקרת זיהום אוויר או התקנים אחרים המותקנים בתעלת הפליטה, יהיו מוגנים על ידי מערכת כיבוי אש אוטומטית.',
        isTitle: false
      },
      {
        section: '10.2',
        title: 'סוגי ציוד',
        isTitle: true
      },
      {
        section: '10.2.1',
        title:
          'ציוד לכיבוי אש חייב לכלול הן מערכות כיבוי אש אוטומטיות, כהגנה ראשונית, והן מטפי כיבוי אש ידניים כגיבוי משני.',
        isTitle: false
      },
      {
        section: '10.2.2',
        title:
          'חובה להציב במקום בולט, בסמוך לכל מטף כיבוי אש, שלט המורה על כך שמערכת כיבוי האש האוטומטית תופעל לפני השימוש במטף הכיבוי.',
        isTitle: false
      },
      {
        section: '10.2.2.1',
        title:
          'הסימון יהיה בשפה העברית ובשפה האנגלית. נוסח הסימון ייקבע על ידי יצרן המערכת.',
        isTitle: false
      },
      {
        section: '10.2.3',
        title:
          'מערכות כיבוי האש האוטומטיות חייבות לעמוד בהוראות תקן ANSI/UL 300 או בהוראות של תקנים שקילים אחרים, וחובה להתקין את המערכות על פי דרישות האישור.\nמערכות כיבוי אש אוטומטיות יעמדו בנוסף גם בדרישות התקן הישראלי ת"י 5356 חלק 2.',
        isTitle: false
      },
      {
        section: '10.2.4',
        title:
          'מתקנים להסרת שומן, תאי אוויר (פלנום) של מנדפי פליטה, תעלות פליטה וציוד בישול שאינם נדונים בתקן ANSI/300 UL, או בתקני בדיקה שקילים אחרים, חייבים בהגנה באמצעות מערכות כיבוי אש אוטומטיות על פי תקני NFPA ישימים, וכן בהתאם לתקנות הבניה והאש המקומיות ולהמלצות היצרן של מערכת כיבוי האש – וכל אלה חייבים באישור הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '10.2.5',
        title:
          'ציוד אוטומטי לכיבוי אש המסופק כחלק ממערכות סחרור חוזר רשומות חייב לעמוד בהוראות תקן ANSI/UL 710B.',
        isTitle: false
      },
      {
        section: '10.2.6',
        title:
          'יש להתקין את מערכות כיבוי האש האוטומטיות על פי תנאי האישור שלהן, בהתאם להוראות היצרן ולפי התקנים המפורטים להלן, ככל שהדבר ישים:\n(1) NFPA 12 - מערכות כיבוי בפחמן דו חמצני\n(2) ת"י 1596 - מערכות מתזים - התקנה\n(3) ת"י 5356 חלק 1 - מערכות כיבוי אש: כיבוי אש בכימיקליים יבשים\n(4) ת"י 5356 חלק 2 - מערכות כיבוי אש: כיבוי אש בכימיקליים רטובים\n(5)  NFPA 750 - מערכת כיבוי אש ברסס מים',
        isTitle: false
      },
      {
        section: '10.2.7',
        title: 'שינויים במערכות מנדפים קיימות',
        isTitle: true
      },
      {
        section: '10.2.7.1',
        title:
          'כל צינור או מוליך נטוש מהתקנה קודמת יוסר מתוך המנדף, תא הקיבול ותעלת הפליטה.',
        isTitle: false
      },
      {
        section: '10.2.7.2',
        title:
          'חדירות וחורים שנבעו מהסרת המוליכים או הצנרת ייאטמו באמצעי איטום רשומים או שקילים האטומים לנוזלים.',
        isTitle: false
      },
      {
        section: '10.2.7.3',
        title:
          'אסור לחסום צורות ריסוס מתוך נחירי מכשיר בישול, כגון לוחיות חוצצות או מדפים, ואסור לעשות בהם כל שינוי.',
        isTitle: false
      },
      {
        section: '10.2.7.4',
        title:
          'שינויים או התאמות לסכנה לאחר ההתקנה של המערכות לכיבוי אש יגרמו הערכה מחודשת של תכנון המערכת בידי אדם מיומן, מוסמך, ומאושר לכך כראוי.\nלכל שינוי במערכות הבישול לאחר התקנתן יידרש אישור מחודש של מעבדה מוסמכת (מעבדה שאושרה על ידי הרשות להסמכת מעבדות).\nבכל מטבח תמצא במקום נגיש ובאופן קבוע תוכנית של מערכות הבישול בקנ"מ 1:50 או 1:100.',
        isTitle: false
      },
      {
        section: '10.2.8',
        title: 'מנדפים בעלי לוחית חוצצת קבועה עם שטף מים',
        isTitle: true
      },
      {
        section: '10.2.8.1',
        title:
          'אזורים הדורשים הגנה על פי האמור בסעיף 10.1.1 יאושרו להיות מוגנים על ידי מערכת שטף מים הרשומה כמערכת כיבוי אש בהתאמה לתקן ANSI/UL 300 או בהוראות של תקנים שקילים אחרים, ויש להתקינה על פי תנאי האישור שלה.',
        isTitle: false
      },
      {
        section: '10.2.8.2',
        title:
          'כל שטח כאמור שאינו מצויד במערכת כיבוי רשומה בשטף מים חייב להיות מצויד במערכת כיבוי הרשומה למטרה זו.',
        isTitle: false
      },
      {
        section: '10.2.8.3',
        title:
          'מכללי מנדפים רשומים בעלי לוחית חוצצת קבועה יכולים לקבלת מים מהספקת המים הביתית, ובלבד שהלחץ ונפח הזרימה המזעריים של המים יעמדו בתנאי האישור.',
        isTitle: false
      },
      {
        section: '10.2.8.4',
        title: 'הספקת המים תבוקר בשסתום בקרת הספקה מפוקח.',
        isTitle: false
      },
      {
        section: '10.2.8.5',
        title:
          'היכן שמערכת כיבוי אש נפרדת משמשת להגנה על ציוד בישול בלבד, מערכת כיבוי אש במים הרשומה להגנה על התקני הסרת השמן, מפלנום מנדף פליטה, תעלות פליטה או שילובם של מי מאלה, תסופק יחד עם הוראות ואמצעים מתאימים לממשק חשמלי להפעלה במקביל.',
        isTitle: false
      },
      {
        section: '10.2.8.6',
        title:
          'כאשר מערכת כיבוי האש האוטומטית משמשת להגנה על ציוד הבישול בלבד, מערכת שטף המים המאושרת להגנה על מתקנים להסרת שומן, תאי אוויר (פלנום) של מנדפי פליטה, תעלות הפליטה או כל צירוף שלהם, חייבת לכלול הוראות וממשק חשמלי הולם להפעלה בו‑זמנית של מערכת שטף המים ומערכת כיבוי האש האוטומטית.',
        isTitle: false
      },
      {
        section: '10.2.8.7',
        title:
          'כשמערכת כיבוי האש האוטומטית, בהתאמה לתקן ת"י 5356 חלק 2 - מערכות כיבוי אש: כיבוי אש בכימיקליים רטובים, מגנה על המנדף והתעלה בלוחית חוצצת קבועה הכוללת מערכת שטף מים, מערכת שטף המים תיעשה לא פעילה או תעוכב ל‑60 שניות לפחות עם הפעלת מערכת כיבוי האש האוטומטית.',
        isTitle: false
      },
      {
        section: '10.2.8.8',
        title:
          'אם תכנון המנדף מונע מהמים להגיע למכשירי הבישול, מותר להגן על מתקנים להסרת שומן, תאי אוויר (פלנום) של מנדפי פליטה ותעלות פליטה במנדפים בעלי לוחית חוצצת קבועה מערכת שטף מים באמצעות מערכת מתזים בעלי שסתום בקרה נפרד.',
        isTitle: false
      },
      {
        section: '10.2.9',
        title: 'מערכת כיבוי אש מבוססת מים',
        isTitle: true
      },
      {
        section: '10.2.9.1',
        title:
          'מערכות כיבוי אש אוטומטיות רשומות יכולות לקבל מים מהספקת המים הביתית, ובלבד שלחץ ההספקה ונפח הזרימה המזעריים יעמדו בתנאי האישור. הספקת המים תבוקר בשסתום בקרת הספקה מפוקח.',
        isTitle: false
      },
      {
        section: '10.2.9.2',
        title:
          'כאשר אספקת המים היא מאספקת מים ייעודית לכיבוי אש בבניין עם מערכת ספרינקלרים המכילה אחד או יותר, יסופקו ויסודרו שסתומי בקרה וניקוזים נפרדים, כך שניתן יהיה לשלוט על מערכות המנדף והספרינקלר באופן פרטני.',
        isTitle: false
      },
      {
        section: '10.2.10',
        title:
          'פיקוח על שסתום המים\n שסתומים המפקחים על הספקת המים למכללי מנדפים רשומים בעלי לוחית חוצצת קבועה, מערכות כיבוי אש אוטומטיות, או שניהם גם יחד, חייבים להיות רשומים תוך ציון סוג השסתום, ויש לפקח על מצב פתוח של שסתומים אלה באחת מהשיטות הבאות:\n(1) תחנה מרכזית קניינית, או שירות אזעקה באמצעות תחנה מרוחקת\n(2) שירות אזעקה מקומי המשמיע אות שמע בנקודה שבה מתקיימת נוכחות אנשים קבועה\n(3) נעילת שסתומים במצב פתוח\n(4)* איטום השסתומים וביצוע ביקורת שבועית מאושרת ורשומה',
        isTitle: false
      },
      {
        section: '10.3',
        title: 'הפעלה בו‑זמנית',
        isTitle: true
      },
      {
        section: '10.3.1',
        title:
          'מערכות כיבוי אש הפועלות באמצעות צינור קבוע באזור סכנה יחיד (ראה סעיף 3.3.44 להגדרת אזור סכנה יחיד) חייבות להיות ערוכות להפעלה אוטומטית בו‑זמנית עם הפעלתה של אחת מבין המערכות.',
        isTitle: false
      },
      {
        section: '10.3.1.1',
        title:
          'מנדפים המותקנים קצה לקצה, גב לגב, או שניהם גם יחד, או חולקים מערכת תעלות משותפת, ויש מתחת לאחד או יותר מהם מכשירים המפיקים שומן, ייחשבו כאזור סכנה יחיד הדורש הגנה אוטומטית בו‑זמנית מפני אש בכל המנדפים והתעלות.',
        isTitle: true
      },
      {
        section: '10.3.1.1.1',
        title:
          "במנדפים המותקנים מקצה לקצה, גב אל גב, או שניהם, ומשתפים תעלה משותפת, תעלה מעבר ל -22.9 מ' (75 רגל) מהמנדף הרחוק ביותר תהיה מוגנת על ידי מערכת כיבוי אש עצמאית בעלת מערכת גילוי נפרדת או על ידי מערכת כיבוי אש המפעילה במקביל עם מערכת כיבוי האש המגנה על המנדפים.",
        isTitle: false
      },
      {
        section: '10.3.1.2',
        title:
          'מנדפים המותקנים קצה לקצה, גב לגב, או שניהם גם יחד, שאינם חולקים מערכת פליטה משותפת, ומופרדים על ידי קיר(ות) או אמצעים אחרים כי להבטיח שאדים נושאי שומן הנפלטים תחת מנדף אחד לא יוכלו להתפשט למנדפים אחרים, מערכות כיבוי האש של המנדפים יהיו עצמאיות ולא ידרשו לפרוק ביחד.',
        isTitle: false
      },
      {
        section: '10.3.1.3',
        title:
          'משרפות אדים, יחידות התאוששות תרמית, התקני בקרת זיהום אוויר או התקנים אחרים המותקנים בתעלת הפליטה לא יידרשו לעמוד ב - 10.3.1.1.',
        isTitle: false
      },
      {
        section: '10.3.2',
        title:
          'הפעלה בו‑זמנית אינה נדרשת כאשר מערכת כיבוי האש באמצעות צינור קבוע היא מערכת מתזים אוטומטית.',
        isTitle: false
      },
      {
        section: '10.3.2.1',
        title:
          'כאשר מערכת ספרינקלרים אוטומטית משמשת בשילוב עם מערכת כיבוי אש מבוססת מים המשורתים על ידי אותה אספקת מים, חישובים הידראוליים ישקלו את שתי המערכות הפועלות בו זמנית.',
        isTitle: false
      },
      {
        section: '10.3.3',
        title:
          'הפעלה בו‑זמנית נדרשת כאשר מערכת כימית יבשה או רטובה משמשת להגנת מערכת תעלות פליטה משותפת באחת מהשיטות המפורטות בתקן ת"י 5356 חלק 1 - מערכות כיבוי אש: כיבוי אש בכימיקליים יבשים או בתקן ת"י 5356 חלק 2 - מערכות כיבוי אש: כיבוי אש בכימיקליים רטובים.',
        isTitle: false
      },
      {
        section: '10.4',
        title: 'ניתוק הספקת דלק וחשמל',
        isTitle: true
      },
      {
        section: '10.4.1',
        title:
          'עם הפעלתה של אחת ממערכות כיבוי האש להגנה על מכשיר בישול, חייבים כל מקורות הדלק וזרם החשמל, המשמשים לחימום של כל פרטי הציוד המוגנים על ידי אותה המערכת, להתנתק באופן אוטומטי.',
        isTitle: false
      },
      {
        section: '10.4.2',
        title: 'קיטור המסופק ממקור חיצוני אינו חייב בניתוק אוטומטי.',
        isTitle: false
      },
      {
        section: '10.4.3',
        title:
          'כל מכשיר גז, שאינו דורש הגנה, אך ממוקם תחת אותו ציוד אוורור, חייב גם הוא בניתוק אוטומטי כאשר מופעלת אחת ממערכות כיבוי האש.',
        isTitle: false
      },
      {
        section: '10.4.4',
        title: 'מתקני הניתוק יהיו בעלי איפוס/הפסקה ידני.',
        isTitle: false
      },
      {
        section: '10.4.5',
        title: 'תהליכי בישול בדלק מוצק לא יידרשו לכיבוי.',
        isTitle: false
      },
      {
        section: '10.5',
        title: 'הפעלה ידנית',
        isTitle: true
      },
      {
        section: '10.5.1',
        title: 'לכל המערכות יהיו שיטות הפעלה אוטומטיות וידניות.',
        isTitle: false
      },
      {
        section: '10.5.1.1',
        title:
          'לפחות אמצעי הפעלה ידני אחד חייב להיות ממוקם ליד היציאה/דרך המילוט או במיקום המקבל על הרשות המוסמכת.\nיותקן שלט שבו הוראות הפעלה ידניות לפי הוראות היצרן, גם בשפה העברית.\nכל מערכות הבישול ימוספרו, ולכל מערכת יוכן שלט נפרד.',
        isTitle: false
      },
      {
        section: '10.5.1.2',
        title:
          "להפעלת ציוד כיבוי האש האוטומטי, הפעלה ידנית באמצעות תחנת משיכה מופעלת בכבל לא תדרוש כוח של יותר מ‑178 ניוטון (40 ליב'), עם תנועת משיכה שלא תעלה על 356 מ\"מ (14 אינץ').",
        isTitle: false
      },
      {
        section: '10.5.2',
        title: 'מערכת מתזים אוטומטית אינה מחייבת התקנת אמצעים ידניים להפעלתה.',
        isTitle: false
      },
      {
        section: '10.6',
        title: 'חיוויי מערכת',
        isTitle: true
      },
      {
        section: '10.6.1',
        title:
          'עם הפעלת מערכת כיבוי האש האוטומטית, יש להבטיח אזעקת שמע או חיווי חזותי כדי להורות כי המערכת מופעלת.',
        isTitle: false
      },
      {
        section: '10.6.2',
        title:
          'כאשר מערכת איתות אזעקת האש משרתת את יושבי המקום שבו ממוקמת מערכת כיבוי האש, ההפעלה האוטומטית של המערכת חייבת להפעיל גם את מערכת איתות אזעקת האש.',
        isTitle: false
      },
      {
        section: '10.7',
        title: 'תכנון ויישום מיוחדים',
        isTitle: true
      },
      {
        section: '10.7.1',
        title:
          'מנדפים המכילים מערכות כיבוי אש אוטומטיות הם אזורים מוגנים. לכן, מנדפים אלה אינם נחשבים כמכשולים למערכות מתזים עיליות ואין הם דורשים כיסוי הרצפה שתחתם.',
        isTitle: false
      },
      {
        section: '10.8.1',
        title:
          'אם נדרש, יש להגיש לרשות המוסמכת שרטוט שלם של התקנת המערכת, כולל מנדפים, תעלות פליטה ומכשירים, יחד עם הממשק של גלאי מערכת כיבוי האש, צנרת, נחירים, מתקנים לניתוק הדלק וזרם החשמל, מכלי אחסון חומרים ומתקנים להפעלה ידנית.\nהתיעוד יישמר ברשותו של בעל הנכס לכל אורך חיי המערכת.',
        isTitle: false
      },
      {
        section: '10.8.2.1',
        title:
          'התקנת מערכות מסופקות תיעשה אך ורק בידי עובדים מיומנים שהוסמכו להתקנת המערכות הספציפיות.',
        isTitle: false
      },
      {
        section: '10.8.2.2',
        title:
          'על המתקין להעביר לרשות המוסמכת תעודה המאשרת כי ההתקנה בוצעה על פי תנאי האישור ובהתאם להוראות היצרן ו/או התכנון המאושר.',
        isTitle: false
      },
      {
        section: '10.9',
        title: 'מטפי כיבוי אש ידניים',
        isTitle: true
      },
      {
        section: '10.9.1',
        title:
          'יש להתקין את מטפי כיבוי האש הידניים בשטחי הבישול במטבח על פי הוראות תקן ת"י 129 חלק 2 - מטפים מיטלטלים: התאמה, התקנה וסימון, ועליהם להיות רשומים ספציפית לשימוש זה.',
        isTitle: false
      },
      {
        section: '10.9.4',
        title: 'אסור להשתמש במטפי כיבוי פחמן דו חמצני',
        isTitle: false
      }
    ]
  },
  {
    section: '12',
    title: 'דרישות בטיחות מזעריות לציוד בישול',
    isTitle: true,
    subCases: [
      {
        section: '12.1',
        title: 'ציוד בישול',
        isTitle: true
      },
      {
        section: '12.1.1',
        title:
          'ציוד בישול חייב להיות מאושר על פי אחד מהקריטריונים הבאים:\n(1) אישור על ידי מעבדת ניסוי\n(2) נתוני בדיקות הקבילים על ידי הרשות המוסמכת\nמכשירים הצורכים גז פחמימני מעובה (גפ"מ) ומכשירים משולבים גז-וחשמל יתאימו לדרישות התקן הישראלי ת"י 5056.',
        isTitle: false
      },
      {
        section: '12.1.2',
        title: 'התקנה.',
        isTitle: true
      },
      {
        section: '12.1.2.1',
        title:
          'יש להתקין את כל המכשירים הרשומים על פי תנאי האישור ובהתאם להוראות היצרן.',
        isTitle: true
      },
      {
        section: '12.1.2.1.1',
        title:
          'דלק מוצק המשמש לטעמים בתוך מכשיר המופעל על ידי גז יהיה בתוך מיכל דלק מוצק (קופסת מעשנים) המצוין בציוד.',
        isTitle: false
      },
      {
        section: '12.1.2.2',
        title:
          'אין להעביר, לשנות או לסדר מחדש את מכשירי הבישול המחייבים הגנה, בלי לערוך, קודם לכן, בחינה נוספת של מערכת כיבוי האש. הבחינה תיערך בידי מתקין המערכת או סוכן השירות אלא אם פעולות כאלה מותרות במסגרת תכנון מערכת כיבוי האש.',
        isTitle: true
      },
      {
        section: '12.1.2.2.1',
        title:
          'לא יתווסף מיכל דלק מוצק למכשיר קיים, עד שמערכת כיבוי האש נבחנהעל ידי ספק שירות מערכת כיבוי האש.',
        isTitle: false
      },
      {
        section: '12.1.2.3',
        title:
          'מערכת כיבוי האש אינה מחייבת בחינה נוספת כשמכשירי הבישול מועברים לטיפולי תחזוקה או ניקיון, ובלבד שלפני ביצוע פעולות בישול נוספות הם מוחזרים למיקומם על פי התכנון המאושר וכל נחירי מערכת כיבוי האש מחוברים למכשירים מחדש בהתאם לספר התכנון הרשום של היצרן.',
        isTitle: true
      },
      {
        section: '12.1.2.3.1',
        title:
          'יש לפעול על פי שיטה מאושרת כדי להבטיח את החזרת המכשירים למקומם על פי התכנון המאושר.',
        isTitle: false
      },
      {
        section: '12.1.2.4',
        title:
          'ציוד לטיגון עמוק יותקנו לפחות במרחק של 406 מ"מ (16 אינץ) בין סיר הטיגון ולהבות בישול של ציוד בישול צמוד.',
        isTitle: false
      },
      {
        section: '12.1.2.5',
        title:
          'הדרישה למרווח של 406 מ"מ (16 אינץ\') לעיל אינה ישימה כאשר לוחית חוצצת בגובה מזערי של 203 מ"מ (8 אינץ\'), מפלדה או מזכוכית מחוסנת, מפריד בין סיר הטיגון לבין להבה גלויה של המכשיר הסמוך',
        isTitle: true
      },
      {
        section: '12.1.2.5.1',
        title:
          'כאשר סיר הטיגון בשמן עמוק והלהבות הגלויות נמצאים במישורים אופקיים שונים, יש למדוד גובה מזערי של 203 מ"מ (8 אינץ\') מן הגבוה מבין השניים.',
        isTitle: false
      },
      {
        section: '12.2',
        title:
          'בקרי הפעלה\nבנוסף לבקרת הטמפרטורה הניתנת לוויסות (תרמוסטט), יש לצייד את הסירים לטיגון בשמן עמוק בבקרה נפרדת להגבלת הטמפרטורה הגבוהה. בקרה זו מיועדת לנתק את הדלק או את האנרגיה כאשר טמפרטורת השמן מגיעה ל‑246°C (475°F) בעומק של 25.4 מ"מ (1 אינץ\') תחת פני השטח.',
        isTitle: false
      }
    ]
  },
  {
    section: '13',
    title: 'מערכות מחזוריות',
    isTitle: true,
    subCases: [
      {
        section: '13.1',
        title:
          'דרישות כלליות\nמערכות מחזוריות הכוללות מכשירים הנמצאים בשימוש בתהליכים המפיקים עשן או אדים נושאי שומן, או מערכות מחזוריות המופעלות עם מכשירים כאלה, חייבות להיות מצוידות ברכיבים העומדים בדרישות המפורטות להלן:\n(1) דרישות המרווחים של סעיף 4.2\n(2) מנדף העומד בדרישות פרק 5\n(3) מתקנים להסרת שומן העומדים בדרישות פרק 6\n(4) דרישות לתנועת אוויר על פי הוראות סעיפים 8.2.1.2 ו 8.2.2.3\n(5) ציוד עזר (דוגמת מתקנים להסרת חלקיקים וריחות) העומד בדרישות פרק 9\n(6) ציוד לכיבוי אש העומד בדרישות פרק 10, מלבד סעיפים 10.1.1 ו 10.5.1 אשר אינם ישימים\n(7) דרישות לשימוש ולתחזוקה על פי פרק 11\n(8) דרישות בטיחות מזעריות המפורטות בפרק 12\n(9) כל הדרישות של פרק 13',
        isTitle: false
      },
      {
        section: '13.2',
        title: 'מגבלות תכנון \nכל מערכות המחזוריות יעמדו בדרישות סעיף 13.2.',
        isTitle: true
      },
      {
        section: '13.2.1',
        title: 'יש להשתמש רק במכשירי בישול המחוממים בגז או בזרם חשמל.',
        isTitle: false
      },
      {
        section: '13.2.2',
        title:
          'ציוד רשום המחומם בגז, המתוכנן לשימוש עם מערכות מחזוריות ספציפיות, חייב להיות מחובר לפתחי ארובה באופן המיועד למטרה זו',
        isTitle: false
      },
      {
        section: '13.2.3',
        title:
          'מכשיר מחומם בגז חייב במרווח מזערי של 457 מ"מ (18 אינץ\') בין מוצא הארובה לפתח הכניסה של המסנן, בהתאם להוראות סעיף 6.2.2 וההתקנה תיעשה לפי הדרישות הנקובות בתקן הישראלי ת"י 158.\nבנושאים שאין עבורם דרישות בתקן הישראלי (ת"י 158) יחולו הדרישות המופיעות בתקן האמריקני NFPA 54.',
        isTitle: false
      },
      {
        section: '13.2.4',
        title:
          'מערכות המחזוריות חייבות ברישום באמצעות מעבדת ניסויים על פי תקן ANSI/UL 710B או תקן שקיל.\nעל  סעיף זה יחולו דרישות סעיף 3.2.4.',
        isTitle: true
      },
      {
        section: '13.2.4.1',
        title:
          'יש לכלול ברישום מערכות הסחרור הגנה מובנית מפני אש למנדפי הסחרור, לרבות סוג החופה.',
        isTitle: false
      },
      {
        section: '13.2.4.2',
        title:
          'מכשירי בישול המחייבים הגנה ונמצאים מתחת למנדף הסחרור יקבלו הגנה ממערכת מובנית להגנה מאש על פי תקן ANSI/UL 710B או במערכת על פי דרישות פרק 10.',
        isTitle: false
      },
      {
        section: '13.2.5',
        title:
          'אין להתיר החלפת מכשירי בישול, רכיבי מסננים, רכיבי מפוחים או רכיבי מערכת כיבוי האש שאינם תואמים את הוראות האישור של המכשיר.',
        isTitle: false
      },
      {
        section: '13.2.6',
        title:
          'מערכת מחזוריות לא תשמש בציוד בישול החורג מן המגבלות המרביות המתויגות של מערכת זו לסוג ציוד זה, ומגבלות אלה יוגדרו במונחים של צריכת אנרגיה מרבית, טמפרטורת בישול מרבית, שטח בישול מרבי או נפח חלל הבישול.',
        isTitle: false
      },
      {
        section: '13.2.7',
        title:
          'על תג האישור להציג את סוג(י) ציוד הבישול שנבדק(ו) ואת מגבלות המקסימום המפורטות בסעיף 13.2.6.',
        isTitle: false
      },
      {
        section: '13.2.8',
        title: 'חובה להתקין מדף (Dumper) מופעל אש במוצא הפליטה של המערכת.',
        isTitle: false
      },
      {
        section: '13.2.9',
        title: 'מדף (Dumper) האש ייבנה מחומר לפחות באותה מידת עובי של העטיפה.',
        isTitle: false
      },
      {
        section: '13.2.10',
        title:
          'מתקן ההפעלה של מדף (Dumper) האש חייב להיות בדירוג טמפרטורה מרבי של 190ºC (375ºF).',
        isTitle: false
      },
      {
        section: '13.2.11',
        title:
          "על הספקת הזרם למשקע אלקטרוסטטי (ESP) להיות מסוג 'ניצוץ קר, הדהוד לא לינארי (ferroresonant), שבו המתח יורד עם עליית זרם הקצר.",
        isTitle: false
      },
      {
        section: '13.2.12',
        title:
          'בבחינת האישור יש לכלול את הנושאים הבאים:\n(1) לכידת האדים מזרמי האוויר שפורסמו ותויגו, וכן הכלת הזרמים האלה\n(2) אסור שכמות השומן הנפלט דרך מוצא הפליטה של המערכת תעלה על ממוצע של 5 מ"ג/מ"ק (0.00018 oz/ft3) של האוויר הנפלט. זאת, בהתאם לדגימת האוויר הנפלט מן הציוד בכמות תוצר מרבית שאפשר לעבד בבדיקה רציפה של 8 שעות על פי הוראות EPA Test Method 202 וכל עוד המערכת פועלת בזרם האוויר הרשום המזערי\n(3) רישום ותיוג המרווח לחומריים בעירים מכל הצדדים, כולל למעלה ולמטה\n(4) חיבור החשמל בשטח על פי חוק החשמל הישראלי התשי"ד-1954 על תקנותיו ועדכוניהם\n(5) מנגנוני נעילה בין כל הרכיבים הניתנים להסרה המותקנים בנתיב זרם האוויר בתוך היחידה. זאת, כדי להבטיח כי הם נמצאים במקומם במהלך הפעולה של מכשיר הבישול.',
        isTitle: false
      },
      {
        section: '13.3',
        title: 'מנגנוני נעילה',
        isTitle: true
      },
      {
        section: '13.3.1',
        title:
          'מנגנוני נעילה יותקנו בכל הרכיבים והמערכות הקריטיים של מערכת המחזוריות, כפי שמצוין בסעיפים 13.3.2 עד 13.3.4, באופן שבו ניתוק אחד מהנועלים המאובטחים ישבית את פעולת מכשיר הבישול.',
        isTitle: false
      },
      {
        section: '13.3.2',
        title:
          'על כל לוחות הסגירה המקיפים קטעי זרימת אוויר להיות מצוידים במנגנוני נעילה כדי להבטיח כי הם נמצאים במקומם ואטומים לחלוטין.',
        isTitle: false
      },
      {
        section: '13.3.3',
        title:
          'על כל רכיב מסנן (שומן וריח) להיות מצויד בשילוב נעילה כדי להבטיח כי הרכיב נמצא במקומו.',
        isTitle: false
      },
      {
        section: '13.3.4',
        title: 'מנגנוני נעילה ESP',
        isTitle: true
      },
      {
        section: '13.3.4.1',
        title:
          'כל ESP יהיה מצויד בחיישן כדי להבטיח כי ביצועיו תואמים את התכנון, ללא הפסקת זרם החשמל לזמן העולה על 2 דקות.',
        isTitle: false
      },
      {
        section: '13.3.4.2',
        title: 'החיישן חייב להיות התקן או מעגל הניתן לאיפוס ידני.',
        isTitle: false
      },
      {
        section: '13.3.5',
        title: 'מתג או מתמר זרם אוויר',
        isTitle: true
      },
      {
        section: '13.3.5.1',
        title:
          'כדי לוודא כי נשמר זרם האוויר המזערי יש להתקין מתג/מתמר זרם אוויר אחרי רכיב הסינון האחרון.',
        isTitle: false
      },
      {
        section: '13.3.5.2',
        title:
          'מתג/מתמר זרם האוויר יפתח את מעגל הנעילה המאובטחת כאשר זרם האוויר נמוך ב‑25% מהזרם הרגיל של המערכת, או נמוך ב‑10% מהמינימום הרשום – הנמוך מבין השניים.',
        isTitle: false
      },
      {
        section: '13.3.5.3',
        title:
          'מתג/מתמר זרם האוויר חייב להיות במתכונת של התקן או מעגל הניתן לאיפוס ידני.',
        isTitle: false
      },
      {
        section: '13.4',
        title: 'מגבלות מיקום ויישום',
        isTitle: true
      },
      {
        section: '13.4.1',
        title: 'מיקום מערכות המחזוריות חייב באישור הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '13.4.2',
        title:
          'נושאים שיש לבחון בהערכת סיכוני האש כוללים, בין השאר, בטיחות חיים, בעירות סביבה, קרבה לפתחי האוורור ועומס דלק כולל.',
        isTitle: false
      },
      {
        section: '13.5',
        title: 'דרישות בטיחות אש נוספות',
        isTitle: true
      },
      {
        section: '13.5.1',
        title:
          'בנוסף לנחירי המכשיר, על מערכת המחזוריות להיות רשומה, כולל מיגון אש נאות למסנני השומן, למערכת סינון השומן, ליחידות סינון הריחות ולמערכת התעלות, ככל שהדבר ישים.',
        isTitle: false
      },
      {
        section: '13.5.2',
        title:
          'בנוסף לכל מתקן הפעלה אחר של מערכת כיבוי האש, יש להתקין מתקן להפעלת מערכת זו במורד הזרם לאחר כל משקע אלקטרוסטטי (ESP).',
        isTitle: false
      },
      {
        section: '13.5.3',
        title: 'דרישות סעיף 10.6 חלות גם על מיקומן של מערכת המחזוריות.',
        isTitle: false
      },
      {
        section: '13.5.4',
        title:
          'למקרה של אש במכשיר, יש להתקין אמצעי להפעלה ידנית של מערכת כיבוי האש בשטח הנגיש באופן בטיחותי.',
        isTitle: false
      },
      {
        section: '13.5.5',
        title: 'יש לסמן בבירור את מתקן ההפעלה הידנית של מערכת כיבוי האש.',
        isTitle: false
      },
      {
        section: '13.6',
        title: 'שימוש ותחזוקה',
        isTitle: true
      },
      {
        section: '13.6.1',
        title:
          'אסור שמכסים אוטומטיים או ידניים של מכשירי הבישול, במיוחד של סירים לטיגון בשמן עמוק, יפריעו לפעולת מערכת דיכוי האש.',
        isTitle: false
      },
      {
        section: '13.6.2',
        title: 'כל המסננים ינוקו או יוחלפו בהתאם להוראות היצרן.',
        isTitle: false
      },
      {
        section: '13.6.3',
        title:
          'כל המשקעים האלקטרוסטטיים (ESP) מחייבים ניקוי לפחות כל שבוע, על פי הוראות היצרן.',
        isTitle: false
      },
      {
        section: '13.6.4',
        title:
          'לפחות כל שלושה חודשים יש לנקות את כל תא הקיבול של המנדף ואת קטע המפוח.',
        isTitle: false
      },
      {
        section: '13.6.5',
        title:
          'לפחות כל שישה חודשים, או לעתים קרובות יותר אם נדרש, יש לערוך, בהתאם להוראות היצרן, ביקורת ובדיקה של כל המערכת ושל כל שילובי הנעילה הבטיחותיים. את הביקורת חייב לבצע צוות שירות מוסמך.',
        isTitle: false
      },
      {
        section: '13.6.6',
        title: 'ביקורת ציוד כיבוי האש תבוצע בהתאם להוראות סעיף 11.2.',
        isTitle: false
      },
      {
        section: '13.6.7',
        title:
          'יש לנהל יומן חתום ומתוארך של טיפולי התחזוקה הנעשים על פי הוראות סעיפים 13.6.4 ו‑13.6.5, והיומן יהיה זמין במקום לשימוש הרשות המוסמכת.',
        isTitle: false
      }
    ]
  },
  {
    section: '14',
    title: 'מערכות בישול בדלק מוצק',
    isTitle: true,
    subCases: [
      {
        section: '14.1',
        title:
          'יישום אוורור \nדרישות האוורור למערכות בישול בדלק מוצק ייקבעו על פי הוראות סעיפים 14.1.1 עד 14.1.7.',
        isTitle: true
      },
      {
        section: '14.1.2',
        title:
          'כאשר ציוד הבישול בדלק מוצק מצויד בחלק עליון עצמאי הוא המכשיר היחיד הדורש אוורור בחלל מבודד (למעט מחמם מים יחיד בעל אוורור נפרד) והוא מקבל את האוויר המחליף ממערכת נפרדת ומחובר להספקת האוויר ולאוויר החוזר (שאינו מסופק מחללים אחרים ואינו מוחזר אליהם) – על המערכת לעמוד בהוראות סעיפים 14.4 ו‑14.6.',
        isTitle: false
      },
      {
        section: '14.1.3',
        title:
          'כאשר ציוד לבישול בדלק מוצק ממוקם בחלל שבו מצוי ציוד מאוורר אחר, כל פרטי הציוד המאווררים יצוידו במערכת פליטה הננעלת בצורה מאובטחת למערכת החלפת האוויר בחלל על פי הוראות סעיף 14.6.',
        isTitle: false
      },
      {
        section: '14.1.4',
        title:
          'מערכות האוורור הפועלות במשב טבעי ומערכות אוורור עם פליטה מונעת חייבות לעמוד בהוראות סעיפים 14.3, 14.4 ו‑14.6.',
        isTitle: false
      },
      {
        section: '14.1.5',
        title:
          'כאשר מכשיר בישול בדלק מוצק מאפשר פליטת חומרים מפתחו, יש להתקין מעל הפתח מנדף ומערכת פליטה העומדת בהוראות סעיפים 14.3, 14.4 ו‑14.6.',
        isTitle: false
      },
      {
        section: '14.1.6',
        title:
          'יש לצייד את מערכת הבישול בדלק מוצק בכולא ניצוצות כדי למזער את מעבר הניצוצות והרשפים, הנישאים באוויר, לתוך תאי הקיבול והתעלות.',
        isTitle: false
      },
      {
        section: '14.1.7',
        title:
          'כאשר מערכת בישול בדלק מוצק אינה ממוקמת תחת מנדף, יש להתקין כולא ניצוצות כדי למזער את מעבר הניצוצות והרשפים לתוך הארובות.',
        isTitle: false
      },
      {
        section: '14.2',
        title: 'מיקום מכשירים',
        isTitle: true
      },
      {
        section: '14.2.1',
        title:
          'יש למקם כל מכשיר, ביחס למבנה הבניין ולציוד אחר, באופן המאפשר גישה אליו.',
        isTitle: false
      },
      {
        section: '14.2.2',
        title: 'אין להתקין מכשירי בישול בדלק מוצק בחללים סגורים.',
        isTitle: false
      },
      {
        section: '14.2.3',
        title:
          'מכשירי בישול בדלק מוצק הרשומים להתקנה בחללים סגורים דוגמת גומחות יותקנו על פי תנאי האישור ובהתאם להוראות היצרן.',
        isTitle: false
      },
      {
        section: '14.2.4',
        title:
          'אין להתקין מכשירי בישול בדלק מוצק בכל מקום שבו מצויים בנזין או אדים/גזים דליקים אחרים כלשהם.',
        isTitle: false
      },
      {
        section: '14.3',
        title: 'מנדפי בישול בדלק מוצק',
        isTitle: true
      },
      {
        section: '14.3.1',
        title:
          'ממדי המנדפים ומיקומם חייבים להבטיח את לכידת כל החומרים הנפלטים מן המכשירים ואת הכלתם.',
        isTitle: false
      },
      {
        section: '14.3.2',
        title: 'המנדף ומערכת הפליטה שלו חייבים לעמוד בדרישות הפרקים 5 עד 10.',
        isTitle: false
      },
      {
        section: '14.3.3',
        title:
          'מלבד מה שמותר בסעיף 14.3.4, מערכות פליטה המשרתות ציוד בישול בדלק מוצק, כולל ציוד המופעל בגז או בחשמל, חייבות להיות נפרדות מכל מערכת פליטה אחרת.',
        isTitle: false
      },
      {
        section: '14.3.4',
        title:
          'ציוד המופעל על ידי גז המופעל באמצעות דלק מוצק לטעם העומד בכל התנאים הבאים, לא יידרש למערכת פליטה נפרדת:\n(1) מיכל הדלק המוצק (קופסת המעשנים) יירשם עם הציוד המופעל באמצעות גז.\n(2) מחזיק הדלק המוצק ימוקם מתחת למבערי הגז.\n(3) יסופקו מעכבי ניצוץ העומדים בקנה אחד עם 14.1.6.\n(4) הכמות המקסימלית של דלק מוצק לא תעלה על 0.45 ק"ג (1 lb) לשעה ל -29.3 קילוואט (100,000 Btu / hr) של קיבולת מבער הגז.\n(5) ציוד המופעל באמצעות גז יוגן על ידי מערכת דיכוי אש המפורטת עבור הציוד, לרבות בעל הדלק המוצק.\n(6) ציוד המופעל על ידי גז עם מחזיקי דלק מוצק, המיועדים לטעמים, כגון charbroiler (קרינה) קורנים, יעמדו בו זמנית בדרישות ANSI / UL 300, אשר יתייחסו לתאי הגזים של רדיוס הגז mesquite עץ charbroiler (ים).\n(7) יותקנו זרבוביות של מערכת כיבוי אש כדי להגן על בעל הדלק המוצק.\n(8) מערכת הדליקה באש תוכננה ותופעל על מנת להגן על כל פעולת הבישול.\n(9) כל בעל דלק מוצק יוגבל לגודל של 2.5 ליטר (150 אינץ \'), ללא מימד העולה על 51 ס"מ (20 אינץ\').\n(10) לכל היותר 29.5 קילוואט (100,000 Btu / hr), או חלק ממנו, של קיבולת מבער, תאושר.\n(11) דלק מוצק יהיה שקוע במים למשך תקופה רצופה של לפחות 24 שעות מיד לפני הנחתו בציוד הבישול.\n(12) תדירות הבדיקה תהיה זהה לזו של פעולות בישול דלק מוצק בלוח 11.4.',
        isTitle: false
      },
      {
        section: '14.3.5',
        title:
          'מתחת למנדף משותף מותר להתקין ציוד בישול שאינו דורש ציוד כיבוי אש אוטומטי (על פי דרישות פרק 10) וציוד לבישול בדלק מוצק המחובר למערכת תעלות נפרדת מכל מערכות הפליטה האחרות.',
        isTitle: false
      },
      {
        section: '14.4',
        title:
          'רמת פליטה לבישול בדלק מוצק \nכאשר מנדף אינו נדרש, בבניינים שבהם מערכת התעלות מגיעה לגובה של שלוש קומות או פחות, יש להתקין תעלה העומדת בדרישות פרק 7.',
        isTitle: true
      },
      {
        section: '14.4.1',
        title:
          'כאשר מנדף משמש בבניינים שבהם גובה מערכת התעלות הוא שלוש קומות או פחות, על מערכת התעלות לעמוד בדרישות פרק 7.',
        isTitle: false
      },
      {
        section: '14.4.2',
        title:
          'כאשר גובה מערכת הפליטה לבישול בדלק מוצק מגיע לארבע קומות או יותר, יש להתקין מערכת תעלות רשומה או מאושרת לפליטת שומן.',
        isTitle: false
      },
      {
        section: '14.4.3',
        title: 'כאשר נעשה שימוש במנדף, על מערכת התעלות לעמוד בדרישות פרק 7.',
        isTitle: false
      },
      {
        section: '14.4.4',
        title: 'במערכות פליטה של דלק מוצק לא יותקנו סיומות קיר.',
        isTitle: false
      },
      {
        section: '14.5',
        title: 'מתקנים להסרת שומן לבישול בדלק מוצק',
        isTitle: true
      },
      {
        section: '14.5.1',
        title:
          'מתקנים להסרת שומן חייבים להיות מיוצרים מפלדה או מפלב"ם, או שעליהם להיות מאושרים לבישול בדלק מוצק.',
        isTitle: false
      },
      {
        section: '14.5.2',
        title:
          'כאשר מערכת בישול בדלק מוצק עלולה להפיק ניצוצות ורשפים הנישאים באוויר, חובה להשתמש במתקנים לכליאת הניצוצות לפני השימוש במתקן להסרת השומן. זאת, כדי למזער את חדירת הניצוצות והרשפים לתוך המתקן להסרת השומן, לתוך המנדף ולתוך מערכת התעלות.',
        isTitle: false
      },
      {
        section: '14.5.3',
        title:
          'המסננים יותקנו בגובה מזערי של 1.2 מטר (4 רגל) מעל שטח הבישול של המכשיר.',
        isTitle: false
      },
      {
        section: '14.6',
        title: 'תנועת אוויר לבישול בדלק מוצק',
        isTitle: true
      },
      {
        section: '14.6.1',
        title:
          'למערכות תחת מנדף הדרישות החלות על מערכת הפליטה תואמות את אלה של פרק 8, ולחלופין יש להתקין את מערכת הפליטה בהתאם להמלצות היצרן ביישומים נעדרי מנדף.',
        isTitle: false
      },
      {
        section: '14.6.2',
        title:
          'יש להתקין מערכת להחלפת אוויר כדי להבטיח הספקה חיובית של אוויר מחליף בכל עת במהלך פעולות הבישול.',
        isTitle: false
      },
      {
        section: '14.6.3',
        title:
          'מערכות האוויר המחליף המשרתות מערכות בישול בדלק מוצק יינעלו בצורה מאובטחת למערכת הפליטה – ואם הדבר נדרש, היו יהיו מונעות כדי למנוע מן החלל להגיע ללחץ אוויר שלילי כשמפעילים מכשיר בישול בדלק מוצק.',
        isTitle: false
      },
      {
        section: '14.7',
        title: 'ציוד כיבוי אש לבישול בדלק מוצק',
        isTitle: true
      },
      {
        section: '14.7.1',
        title:
          'ההגנה על מכשירי בישול בדלק מוצק המפיקים אדים נושאי שומן תיעשה באמצעות ציוד כיבוי אש רשום.',
        isTitle: false
      },
      {
        section: '14.7.2',
        title:
          'כאשר הדבר קביל על ידי הרשות המוסמכת, מכשירי בישול בדלק מוצק הבנויים מלבנים מוצקות או מבטון מזוין (ממלט פורטלנד או מלט חסין אש) ומאווררים על פי הוראות תקן NFPA 211, אינם מחויבים בציוד כיבוי אש אוטומטי קבוע.',
        isTitle: false
      },
      {
        section: '14.7.3',
        title:
          'להגנת מתקנים להסרת שומן, מנדפים ומערכות תעלות יש להתקין ציוד רשום לכיבוי אש.',
        isTitle: false
      },
      {
        section: '14.7.4',
        title:
          'כאשר הדבר קביל על ידי הרשות המוסמכת, מכשירי בישול בדלק מוצק הבנויים מלבנים מוצקות או מבטון מזוין (ממלט פורטלנד או מלט חסין אש) ומאווררים על פי הוראות תקן NFPA 211, אינם מחויבים בציוד כיבוי אוטומטי לצורך הגנת המתקנים להסרת שומן, המנדפים ומערכות התעלות.',
        isTitle: false
      },
      {
        section: '14.7.5',
        title:
          'ציוד כיבוי אש רשום עבור מכשירי בישול בדלק מוצק, אם נדרש, חייב לעמוד בהוראות פרק 10 ולהשתמש בחומרים מבוססי מים.',
        isTitle: false
      },
      {
        section: '14.7.6',
        title:
          'ציוד כיבוי אש חייב להיות מדורג ומתוכנן לכיבוי פריצת אש בבישול בדלק מוצק.',
        isTitle: false
      },
      {
        section: '14.7.7',
        title:
          'ממדי ציוד כיבוי האש חייבים להבטיח כיבוי אש מושלם באזור הסכנה כולו ולמנוע הצתה מחודשת של הדלק.',
        isTitle: false
      },
      {
        section: '14.7.8',
        title:
          'כל המכשירים לדלק מוצק (בין אם מותקנים מתחת למנדף ובין אם לאו), המצוידים בתיבות אש בנפח 0.14 מ"ק (5 רגל מע\') או פחות, מחייבים לפחות מטף כיבוי רשום ברסס מים המדורג 2‑A או מטף כיבוי כימי רטוב של 6 ל\' (1.6 גלון) הרשום לשריפות מסוג K על פי תקן ת"י 129 חלק 2 - מטפים מיטלטלים: התאמה, התקנה וסימון עם אורך מהלך מרבי של 6 מטר (20 רגל) אל המכשיר.',
        isTitle: false
      },
      {
        section: '14.7.9',
        title: 'הגנת זרנוק.',
        isTitle: true
      },
      {
        section: '14.7.9.1',
        title:
          'מכשירי דלק מוצק המצוידים בתיבות אש שממדיהן עולים על 0.14 מ"ק (5 רגל מע\') מחייבים להתקין במטבח צנרת מים קבועה עם זרנוק המסוגל להגיע לתיבות האש.',
        isTitle: false
      },
      {
        section: '14.7.9.1.1',
        title:
          'הזרנוק חייב להיות מצויד בנחיר מתכוונן היכול לחולל רסס או רסס עדין עד בינוני.',
        isTitle: false
      },
      {
        section: '14.7.9.1.2',
        title: 'הנחיר יהיה מסוג שאינו יכול להפיק זרם מים ישר.',
        isTitle: false
      },
      {
        section: '14.7.9.2',
        title:
          "לחץ הפעולה המזערי של המערכת חייב להגיע ל‑275.8 kpa (40 psi) ותפוקתה המזערית חייבת להגיע ל‑19 ל'/דק' (5 גלון/דק').",
        isTitle: false
      },
      {
        section: '14.7.10',
        title:
          'מערכת דיכוי האש בשטחי אחסון הדלק חייבת לעמוד בהוראות סעיף 14.9 לתקן זה.',
        isTitle: false
      },
      {
        section: '14.7.11',
        title:
          'בנוסף לדרישות הסעיפים 14.7.8 עד 14.7.10, כאשר מכשיר בישול בדלק מוצק מצויד גם בהצתת עזר באמצעות חשמל, גז, נפט או דלק אחר, או שהוא מחובר למקור חום נוסף, והוא מוגן על ידי חלק של מערכת כיבוי אש העומדת בדרישות פרק 10, עם הפעלתה של מערכת כיבוי האש יש להבטיח ניתוק של מקורות הצתת העזר/החום האמורים.',
        isTitle: false
      },
      {
        section: '14.9',
        title:
          'דרישות בטיחות מזעריות: אחסון וטיפול בדלק וכן פינוי אפר לבישול בדלק מוצק',
        isTitle: true
      },
      {
        section: '14.9.1',
        title: 'מרווחי התקנה',
        isTitle: true
      },
      {
        section: '14.9.1.1',
        title:
          'יש להתקין את המכשירי בישול בדלק מוצק על רצפה לא בעירה המשתרעת למרחק של 0.92 מטר (3 רגל) לכל הכיוונים סביב המכשיר.',
        isTitle: false
      },
      {
        section: '14.9.1.2',
        title:
          'רצפות בעלות משטחים לא בעירים מותרות לשימוש זה כשהן מאושרות למטרה על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '14.9.1.3',
        title: 'מותר להשתמש במכללי רצפות הרשומים ליישומים של מכשירי דלק מוצק.',
        isTitle: false
      },
      {
        section: '14.9.1.4',
        title:
          'מכשירי בישול בדלק מוצק הרשומים למרווח אפס בינם לבין חומרים בעירים מתחתם ומצדיהם, והם מצוידים באח חימום מאושרת המשתרעת למרחק של 0.92 מטר (3 רגל) לכל כיוון מדלתות השירות, מותרים לשימוש על רצפות בעירות.',
        isTitle: false
      },
      {
        section: '14.9.1.5',
        title:
          'משטחים ומבנים בעירים או בעירים באופן מוגבל חייבים בהגנה הקבילה על ידי הרשות המוסמכת עד למרחק של 0.92 מטר (3 רגל) מצדי מכשיר הבישול בדלק מוצק או 1.8 מטר (6 רגל) מעליו.',
        isTitle: false
      },
      {
        section: '14.9.1.6',
        title:
          'מכשירי בישול בדלק מוצק, הרשומים באופן ספציפי למרווח קטן יותר בינם לבין חומרים בעירים, מותרים להתקנה על פי דרישות האישור ובהתאם להוראות היצרן.',
        isTitle: false
      },
      {
        section: '14.9.3.7',
        title: 'הגנת זרנוק.',
        isTitle: true
      },
      {
        section: '14.9.3.7.1',
        title:
          'למטרות סעיף 14.9.3.6.3, כדי לצנן אש שהפכה חמה מדי וכדי לכבות כל אש לפני פינוי בני אדם ממקום הבעירה, יש להתקין הספקת מים עם זרנוק גמיש ליד מכשיר הבישול בדלק מוצק.',
        isTitle: false
      },
      {
        section: '14.9.3.7.2',
        title:
          "במכשירים המצוידים בתיבות אש שאינן מעל 0.14 מ\"ק (5 רגל מע') מותר לספק מים ממכל בעל קיבולת של 37.9 ל' (10 גלון) אשר יבטיח לחץ מים בכבידה או בעזרת משאבה ידנית.",
        isTitle: false
      },
      {
        section: '14.9.3.7.3',
        title:
          'במכשירים המצוידים בתיבות אש מעל 0.14 מ"ק (5 רגל מע\') יש לספק את המים באמצעות צנרת מים קבועה עם זרנוק באורך שיספיק כדי להגיע לתאי הבעירה והבישול של המכשיר.',
        isTitle: false
      },
      {
        section: '14.9.3.7.4',
        title:
          'בכל אחד מן היישומים, הנחיר יצויד בברז ידני ויהיה מסוג המפיק רסס עדין עד בינוני לטווח המאפשר להגיע לכל האזורים בתאי הבעירה והבישול.',
        isTitle: false
      },
      {
        section: '14.9.3.7.4.1',
        title:
          'הנחיר יהיה מסוג שאינו יכול להפיק זרם מים ישר.\nעל המנדף יותקן שילוט אזהרה בר קיימה, שייכתב בו: "בעת כיבוי אש במים, יש להשתמש בנחיר במצב רסס בלבד".\nגודל האותיות בשילוט לא יהיה קטן מ-6 מ"מ.',
        isTitle: false
      },
      {
        section: '14.9.4',
        title: 'דרישות בטיחות אחרות',
        isTitle: true
      },
      {
        section: '14.9.4.1',
        title:
          'מכשירים מתכתיים לבישול בדלק מוצק, המיוצרים בכמויות מעשיות, חייבים להיות רשומים ליישומם או מאושרים על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '14.9.4.2',
        title:
          'כאשר הם רשומים, יש להתקין את המכשירים המתכתיים לבישול בדלק מוצק על פי תנאי האישור ובהתאם לדרישות הישימות של תקן זה.',
        isTitle: false
      },
      {
        section: '14.9.4.3',
        title: 'מכשירי בישול בדלק מוצק בנויים באתר.',
        isTitle: true
      },
      {
        section: '14.9.4.3.1',
        title:
          'לפני התקנתם, חייבים, מכשירי בישול בדלק מוצק הבנויים באתר, באישור הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '14.9.4.3.2',
        title:
          'כל היחידות המוגשות לרשות המוסמכת יותקנו, יופעלו ויתוחזקו על פי התנאים המאושרים של הוראות היצרן, ובהתאם לכל הדרישות הנוספות של הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '14.9.4.4',
        title:
          'במכשיר בישול בדלק מוצק אין להתקין אמצעים נוספים מסוג כלשהו באף חלק של המכשיר, צינור הארובה או הארובה עצמה למעט כולא הניצוצות הנדרש על פי סעיף 14.1.6.',
        isTitle: false
      },
      {
        section: '14.9.4.5',
        title:
          "במכשיר בישול בדלק מוצק מכל סוג, אין להתיר טיגון בשמן עמוק בקיבולת העולה על 0.95 ל' (רבע גלון) של שומן נוזלי. כמו כן, אין להתיר התקנת מכשיר בישול בדלק מוצק במרחק הקטן מ‑0.92 מטר (3 רגל) מיחידה לטיגון בשמן עמוק.",
        isTitle: false
      }
    ]
  },
  {
    section: '15',
    title: 'מערכות אוורור של מכשירים עיליים',
    isTitle: true,
    subCases: [
      {
        section: '15.1',
        title: 'דרישות כלליות',
        isTitle: true
      },
      {
        section: '15.1.1',
        title:
          'מערכות אוורור של מכשירים עיליים שמכילות מכשירים העושים שימוש בתהליכים מפיקי עשן או אדים נושאי שומן או שמיועדות לשימוש עם מכשירים כאלה, יצוידו ברכיבים העומדים בדרישות אלה:\n(1) דרישות המרווחים של סעיף 4.2\n(2) אמצעי איסוף עיקרי אשר מתוכנן לאיסוף אדי בישול ושאריות ועומד בדרישות פרק 5\n(3) מתקנים להסרת שומן העומדים בדרישות פרק 6\n(4) מסננים למטרה מיוחדת כפי שהם רשומים על פי תקן UL 1046\n(5) תעלות פליטה תואמות פרק 7\n(6) דרישות לתנועת אוויר על פי הוראות סעיפים 8.2.1.2 ו 8.2.2.3\n(7) ציוד עזר (דוגמת מתקנים להסרת חלקיקים וריחות) העומד בדרישות פרק 9\n(8) ציוד לכיבוי אש העומד בדרישות פרק 10 ולמצוין בסעיף 15.2\n(9) דרישות לשימוש ולתחזוקה על פי פרק 11 (10) דרישות בטיחות מזעריות המפורטות בפרק 12',
        isTitle: false
      },
      {
        section: '15.1.2',
        title:
          'מערכת אוורור של מכשיר עילי חייבת להבטיח את לכידת כל החומרים הנפלטים מתוך המכשיר שהיא משרתת ואת הכלתם.',
        isTitle: false
      },
      {
        section: '15.2',
        title:
          'ציוד כיבוי אש \nבציוד כיבוי אש במערכות אוורור של מכשירים עיליים חובה להחיל את התנאים הבאים:\n(1) יש להבטיח הגנה למשטח הבישול, לתעלה ולתא הקיבול.\n(2) יש להתקין לפחות חיבור נתיך או גלאי חום אחד בתוך כל פתח תעלת פליטה בהתאם לרישומי היצרן.\n(3) יש להתקין חיבור נתיך או גלאי חום מעל כל מכשיר בישול מוגן ובהתאם לרישומי היצרן של מערכת כיבוי האש.\n(4) יש להתקין מתקן הפעלה ידנית כחלק מכל מכשיר בגובה קביל על ידי הרשות המוסמכת.\n(5) יש להתקין מטפי כיבוי אש ידניים על פי סעיף 10.9.',
        isTitle: true
      },
      {
        section: '15.2.1',
        title:
          'מערכת אוורור רשומה של מכשירים עיליים העושה שימוש במערכת כיבוי אש מובנית עם מערכות גילוי ללכידת שומן ועשן, כיבוי אש וגילוי תיחשב כעומדת בהוראות סעיף 15.2.',
        isTitle: false
      },
      {
        section: '15.2.2',
        title:
          'מערכת האוורור של מכשירים עיליים תצויד במנגנוני נעילה שלא יאפשרו הספקת דלק בישול אלא אם הופעלו מערכות הפליטה ואוויר ההספקה.',
        isTitle: false
      },
      {
        section: '15.3',
        title: 'מתג או מתמר זרם אוויר',
        isTitle: true
      },
      {
        section: '15.3.1',
        title:
          'כדי לוודא כי נשמר זרם האוויר המזערי יש להתקין מתג/מתמר זרם אוויר לאחר רכיב הסינון האחרון.',
        isTitle: false
      },
      {
        section: '15.3.2',
        title:
          'מתג/מתמר זרם האוויר יפתח את מעגל הנעילה המאובטחת כאשר זרם האוויר נמוך ב‑25% מהזרם הרגיל של המערכת, או נמוך ב‑10% מהמינימום הרשום – הנמוך מבין השניים.',
        isTitle: false
      },
      {
        section: '15.3.3',
        title:
          'מתג/מתמר זרם האוויר חייב להיות במתכונת של התקן או מעגל הניתן לאיפוס ידני.',
        isTitle: false
      },
      {
        section: '15.4',
        title: 'חומרי משטחים',
        isTitle: true
      },
      {
        section: '15.4.1',
        title:
          'כל משטח הממוקם ישירות מעל מכשיר הבישול חייב להיות עשוי מחומרים לא בעירים או בעלי בעירות מוגבלת.',
        isTitle: false
      }
    ]
  }
];
